export const bannerImages = [
    { src: "./assets/img/banner/banner.jpg", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
    { src: "./assets/img/banner/ment-1.JPG", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
    { src: "./assets/img/banner/ment-11.jpg", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
    { src: "./assets/img/banner/ment-4.JPG", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
    { src: "./assets/img/banner/ment-3.JPG", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
    { src: "./assets/img/banner/IMG_1005.JPG", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
    { src: "./assets/img/banner/Banner-5.jpg", alt: 'banner', description: "Together we are changing lives, one girl at a time." },
];

export const aboutImages = [
    { src: 'assets/img/about/rachael.jpg', alt: 'beads', title: 'Sponsoring', description: 'Sponsoring girls with monthly donations.' },
    { src: 'assets/img/about/mentor.JPG', alt: 'beads', title: 'Mentoring', description: 'Mentoring girls through education.' },
    { src: 'assets/img/about/Build-School.jpg', alt: 'beads', title: 'Building Schools', description: 'Building schools for the Maasai communities.' },
    { src: 'assets/img/about/Sponsoring.JPG', alt: 'beads', title: 'Sponsor A Girl', description: 'Sponsoring a girl through support and empowerment.' },
    { src: 'assets/img/about/Foster.JPG', alt: 'beads', title: 'Fostering Programs', description: 'Creating programs that supports the local communities.' },
    { src: 'assets/img/about/Donate.JPG', alt: 'beads', title: 'Donate', description: 'Support us with monthly donations.' },
];

export const serviceList = [
    {
        title: 'Donate',
        des: 'You can support us with one-time donation or Monthly-donation.',
        img: 'assets/img/service/11.jpg',
    },
    {
        title: 'Sponsor a girl',
        des: 'You can support us with one-time donation or Monthly-donation.',
        img: 'assets/img/service/Rebecca.jpeg',
    },
    {
        title: 'Mentoring a girl',
        des: 'You can support us with one-time donation or Monthly-donation.',
        img: 'assets/img/service/ment-10.JPG',
    }
];

export const partnersData = [
    { href: "https://www.awf.org/", src: 'assets/img/client/AWFLogo.jpg', alt: 'AWF' },
    { href: "https://www.serenahotels.com/", src: 'assets/img/client/Serena_Hotels_Logo2.png', alt: 'Serena' },
    { href: "https://www.jabberwockybookshop.com/", src: 'assets/img/client/Jabberwocky-logo.jpg', alt: 'jwb' },
    { href: "https://www.aidforafrica.org/", src: 'assets/img/client/AidForAfrica.png', alt: 'AFA' },
    { href: "https://www.awf.org/", src: 'assets/img/client/AWFLogo2.png', alt: 'AWF' },
    { href: "https://www.serenahotels.com/", src: 'assets/img/client/serena-hotel-logo.gif', alt: 'Serena' },
    { href: "https://www.jabberwockybookshop.com/", src: 'assets/img/client/jabberwocky Red Logo.png', alt: 'jwb' },
    { href: "https://www.aidforafrica.org/", src: 'assets/img/client/AidForAfrica2.gif', alt: 'AFA' },

];

export const recentNewsHome = [
    {
        id: '411',
        category: 'Beads Graduation',
        title: 'BEADS FOR EDUCATION 5TH GRADUATION CEREMONY 2023',
        content: 'This also marks the 10th Anniversary for Beads Tembea Academy, a school established by BEADS for Education in the year 2023 to provide quality education and critical thinking skills...',
        imgSrc: 'assets/img/blog/Graduation.jpg',
        alt: 'graduation',
        date: '20-12-2023',
        author: 'Debbie',
        link: '/news',
    },
    {
        id: '412',
        category: 'Other News',
        title: 'SPORTS COMPETITION',
        content: 'Tembea Academy the sports powerhouse! Another success for both the soccer and netball team proceeding to the next level! We are proud of the girls and thankful for all the support they are receiving...',
        imgSrc: 'assets/img/blog/Sports.JPG',
        alt: 'sports',
        date: '30-05-2022',
        author: 'Auditor',
        link: '/news',
    },
    {
        id: '413',
        category: 'Featured News',
        title: 'MR. MAGAGA VISITS WATKISON SCHOOL-USA',
        content: 'One of our teacher’s Mr. Magaga Enos visited Watkinson School located in the Harford Connecticut USA. He received a warm welcome from both the staff and the students. BEADS fraternity is very humbled by the support that our students get from the school...',
        imgSrc: 'assets/img/blog/USA-Visit.jpg',
        alt: 'USA-Visit',
        date: '20-01-2023',
        author: 'Debbie',
        link: '/news',
    },
];

export const directorsData = [
    {
        name: 'DEBBY ROONEY',
        role: 'CO-FOUNDER',
        image: 'assets/img/board/DebbyRooney.jpg',
        alt: 'Debby Rooney',
        description: 'In 1993, Debby began working with women’s business development in the Maasai regions of southern Kenya. In 1998, she began the sponsorship program for girls’ education. Her work experience includes sales, advertising, public relations, high school teacher and environmental education. Debby personally funded all start up costs for BEADS for Education. She holds a B.A. in Education from Penn State University.',
    },
    {
        name: 'LISA STEVENS, EMERITUS',
        role: 'CURATOR, PANDAS AND PRIMATES, SMITHSONIANS’ NATIONAL ZOO, WASHINGTON, D.C.',
        image: 'assets/img/board/lisastevens.png',
        alt: 'Lisa Stevens',
        description: 'Lisa Stevens has managed all aspects of the Zoo`s giant panda program since 1987, and the primate program since 1981. Her areas of supervision include daily operations, personnel, budget, long-range planning, record keeping, research, education, exhibit design, and construction. Before working at the Zoo, Stevens worked as a field research assistant, in pet and aquarium retail, veterinary clinic operations, insect zoo husbandry and interpretation, and riding stable management. Stevens participates in the Association of Zoos and Aquariums` Species Survival Plan for several species. Through Friends of the National Zoo, International Expeditions, SI Journeys and World Wildlife Fund, Stevens has been a tour leader for natural history tours in Africa, Madagascar, India, and South America. She holds a Bachelor of Science degree, zoology/pre-veterinary medicine, from Michigan State University.',
    },
    {
        name: 'JEFFREY P. ELEFANTE. ESQ',
        role: null,
        image: 'assets/img/board/jeffelefante.png',
        alt: 'Jeffel Efante',
        description: 'Jeffrey P. Elefante retired in 2005 as Executive VP, General Counsel, Secretary and Director of Contract and Administrative Services of CACI International Inc, a multi-billion dollar government contractor whose securities are traded on the New York Stock Exchange under the symbol CAI. A valued member of CACI`s top management team between 1992 and 2005, Mr. Elefante offers more than 28 years of experience as a senior executive, counselor, negotiator and consultant on corporate governance and dispute resolution. He has significant experience as a board member for several non-profit organizations, as well. Mr. Elefante earned a bachelor`s degree in political science from West Virginia University in May 1968.In 1974 he received his juris doctor degree from Georgetown University Law Center. Mr. Elefante resides in Washington, D.C. with his wife.',
    },
    {
        name: 'DR. BERNHARD HEERSINK',
        role: null,
        image: 'assets/img/board/bernhardheersink.png',
        alt: 'Bernhard Heersink',
        description: 'Bernhard Heersink, M.D. is a practicing (33 years) ophthalmologist in Newburyport, Massachusetts. He is a graduate of the University of Western Ontario in London, Canada. He is a Clinical Associate on the faculty of Tufts University School of Medicine in Boston, Massachusetts. He has served as Chief of the Department of Surgery and President of the Medical Staff of Anna Jaques Hospital in Newburyport, and as a Board member for the Pregnancy Care Center in Haverhill, Massachusetts. He is currently serving on the Board of Stewardship and Finance for the Belleville Congregational Church in Newburyport, Massachusetts. He volunteered with CUSO (the Canadian counterpart to the Peace Corps) in Uganda 1971-72, doing mostly general surgery, and has been on two BEADS-related visits to Kenya in 2005 and 2010.',
    },
    {
        name: 'LINDA MACHT',
        role: 'CO-FOUNDER',
        image: 'assets/img/board/linda.png',
        alt: 'Linda Macht',
        description: 'Linda Reichart Macht is the President and CEO of Tottser Tool and Manufacturing located in PA. She is the Founder and President of Garden of Eve, an organization determined to enrich the lives of women around the world. The Garden of Eve’s first project was Beads for Education where she sits on the board as Secretary. She is a member of PWDC Industry Partnership, WBENC (Women’s Business Executive National Council), Rydal Meadowbrook Civic Ass. and Abington Art Center. She was a speaker for the Executive Leadership Radio. Ms. Macht earned a bachelor’s degree in business administration from Shippensburg University in 1979. She resides in Rydal, PA.',
    },
    {
        name: 'SUE LITTLE',
        role: 'OWNER AND FOUNDER, JABERWOCKY BOOKSTORE, NEWBURYPORT, MA',
        image: 'assets/img/board/suelittle.png',
        alt: 'Sue Little',
        description: 'Thirty-seven years ago Sue Little opened Jabberwocky (the Little Bookshop) in Newburyport, MA. Today, they are one of the largest independent bookstores on the Northshore. Their goal is quite simply to offer the community the most unique, the most beautiful, the most interesting, the most timely, and the most entertaining books. And now she brings this love of reading to the students of BEADS for Education.',
    },
    {
        name: 'WILLIAM J. ROONEY',
        role: null,
        image: 'assets/img/board/bill+rooney.jpg',
        alt: 'Bill Rooney',
        description: 'Bill Rooney has served as Treasurer for BEADS for Education (“BEADS”) since its incorporation. He is husband to the co-founder of BEADS, Debby Rooney. In addition to the financial reporting and record keeping responsibilities of his position, he is also responsible on a daily basis to help Debby ensure the organization stays on course and true to its mission. Mr. Rooney spent his entire 35-year professional career in the information technology field, holding positions in technology development, sales, sales management, finance, executive management and management consulting. An accomplished golfer, he served (6) years on the Board of Governors at a prestigious golf club as Treasurer and President of the Club. Mr. Rooney has traveled to Africa several times in support of BEADS and is the author of the BEADS motto – “Changing lives – one girl at a time”. Mr. Rooney attended Fairfield University, majoring in Economics.',
    },
    {
        name: 'C. MARSHALL GORMAN',
        role: null,
        image: 'assets/img/board/blank.jpg',
        alt: 'Linda Macht',
        description: 'Marshall Gorman retired in 2016 from the Matawan Aberdeen Regional School District after teaching Social Studies for 22 years. He also held the positions of Treasurer, Vice-President and President of the Matawan Regional Teachers Association over the course of 15 years of service. Mr. Gorman taught courses in Anthropology, Sociology, Psychology and Human Services at three different colleges: Wagner College, Brookdale Community College and Montgomery County Community College for more than 12 years. He also worked as the Director of Continuing Education for Wagner College for three years. Mr. Gorman earned a BA in Anthropology from Franklin & Marshall College in 1978; a MA in Anthropology from Columbia University in 1981; Certification as a Social Studies teacher from Monmouth University in 1993. He resides with his wife, Becky, in Freehold, NJ. Mr. Gorman has been on one BEADS related visit to Kenya in 2017.',
    },
    {
        name: 'CYNTHIA MOSS',
        role: 'PROGRAM DIRECTOR AND TRUSTEE, AMBOSELI TRUST FOR ELEPHANTS (ATE)',
        image: 'assets/img/board/cynthiamoss.jpeg',
        alt: 'Cynthia Moss',
        description: 'Born and educated in the U.S.A., Cynthia Moss moved to Africa in 1968 and has spent the past 42 years there studying elephants and working for their conservation. Her involvement with elephants began in Lake Manyara National Park in Tanzania where she worked with Iain Douglas-Hamilton on his pioneering elephant study. In 1972, with Harvey Croze, she started the Amboseli Elephant Research Project (AERP) in Kenya which she continues to direct. Her studies have concentrated on the distribution, demography, population dynamics, social organization and behavior of the Amboseli elephants. In 2001 she created the Amboseli Trust for Elephants in both Kenya and the USA. Her present activities include: overall direction of ATE which includes: research and monitoring; training elephant researchers from African elephant range states; outreach to the Maasai community in Amboseli; disseminating scientific results; networking with other elephant scientists and conservation in Africa and Asia; and promoting public awareness by writing popular articles and books and by making films about elephants. Moss is the author of four books: Portraits in the Wild (University of Chicago Press); Elephant Memories (University of Chicago Press); Echo of the Elephants (William Morrow); Little Big Ears (Simon & Schuster); and co-author with Laurence Pringle of Elephant Woman (Atheneum). She has written numerous popular and scientific articles and has made four award-winning TV documentaries about elephants.',
    },
    {
        name: 'DR. HELEN GICHOHI',
        role: 'PRESIDENT, AFRICAN WILDLIFE FOUNDATION',
        image: 'assets/img/board/helengichohi.jpeg',
        alt: 'Helen Gichohi',
        description: 'Dr. Helen Gichohi joined the African Wildlife Foundation in February 2001 as Director of the African Heartlands Program and quickly moved on to become the Vice President for Program in February 2002. She was elected President of the organization by the Board of Trustees in January 2007. Dr. Gichohi provides overall strategic leadership to AWF’s Conservation Program in Africa. She is responsible for building strong partnerships with large donors for funding of AWF’s conservation work and represents the organization at the highest levels of government in Africa. <br /> She also serves on the board of Trustees of the Kenya Wildlife Service. Prior to joining AWF, she was the Director of the African Conservation Centre (ACC), supported by Wildlife Conservation Society, where her key focus had been to provide vision, leadership and strategic direction towards the development of the ACC as a centre for conservation excellence. <br /> Dr. Gichohi is a graduate of the University of Leicester, where she attained her Doctor of Philosophy degree in Ecology. She also holds a Master of Science degree in Biology of Conservation and a Bachelor of Science degree in zoology from University of Nairobi and Kenyatta University respectively.',
    },
    {
        name: 'IRENE KATETE',
        role: null,
        image: 'assets/img/board/irenekatete.jpg',
        alt: 'Irene Katete',
        description: 'Irene Katete Nairowua, is the Assistant Community Development Officer (A.C.D.O) in charge of social welfare for the County Council of the Kajiado District. Her responsibilities include HIV/AIDS trainings in the community and work place. She is in charge of Drug and Substance Abuse campaigns and community trainings. Works with the community, local NGO’s and the private sector to implement these programs.<br /> Irene is a Maasai woman from the Kajiado District and works in her home region. She is a member of the BEADS for Education PTA and supervises the programs for the sponsored girls in Kenya.',
    },
];

export const pressItems = [
    {
        href: 'https://www.project-greet.com/debby-rooney.html',
        imgSrc: 'assets/img/press/debby-rooney_2.jpg',
        title: "GREET Project Debby Rooney",
        description: "Deborah Kling Rooney is the co-founder of BEADs for Education, a non-profit that improves the status of Kenyan women by offering business development and primarily girls' education.",
        externalLinks: []
    },
    {
        href: 'https://www.ashoka.org/en-us/story/rebecca-changemaker-story',
        imgSrc: 'assets/img/press/Rebecca-book.png',
        title: "Rebecca’s Book",
        description: [
            "Rebecca’s Book is published by ",
            { text: "Ashoka", url: "https://www.ashoka.org/en-us" },
            " and ",
            { text: "Worldreader.", url: "https://www.worldreader.org/" },
            " Rebecca, The Maasai Changemaker is inspired by the true story of a young girl in Kenya who was alarmed by the signs of climate change in her community."
        ],
        externalLinks: []
    },
    {
        href: 'https://www.psu.edu/news/campus-life/story/college-liberal-arts-honors-alumni-faculty-during-annual-awards-ceremony/',
        imgSrc: 'assets/img/press/Penn-state-col.png',
        title: "Penn State University Service to Society Award 2017",
        description: "The Penn State College of the Liberal Arts honored several alumni and one of its faculty members during its annual Alumni Awards Ceremony on Friday, April 21 at The Nittany Lion Inn.",
        externalLinks: []
    },
    {
        href: 'https://www.ashoka.org/en-us/story/rebecca-changemaker-story',
        imgSrc: 'assets/img/press/Rebecca-change.jpg',
        title: "Every Girl a Changemaker",
        description: "A generation of young Kenyans is stepping up to create positive change to address everyday challenges that are enflamed by the climate crisis. Rebecca's story describes the courage and ambition of young people who are translating knowledge into action for a better world.",
        externalLinks: []
    },
    {
        href: "assets/files/AWFNewsletter.pdf",
        imgSrc: 'assets/img/press/AWF-Newsletter.png',
        title: "African Wildlife Foundation Newsletter",
        description: "With the support from African Wildlife Foundation Newsletter(AWF), Beads organization helps in improving the livelihoods of Maasai communities lining in Kenya.",
        externalLinks: []
    },
    {
        href: "assets/files/ElleCanada.pdf",
        imgSrc: 'assets/img/press/Elle-Mag.png',
        title: "Elle Canada",
        description: "BEADS for Education first focused on selling the beadwork of the Dupoto Women's group to help those women send their daughters to school.",
        externalLinks: []
    },
    {
        href: "assets/files/Ms_Magazine.pdf",
        imgSrc: 'assets/img/press/ms-mag.png',
        title: "Ms Magazine_Beads",
        description: "Maasai women work to give their daughters more choice than they had. They money earned from the beadwork is used to send their daughters to school.",
        externalLinks: []
    },
    {
        href: "assets/files/BeadAndButton.pdf",
        imgSrc: 'assets/img/press/BeadAndButton.png',
        title: "Bead & Button",
        description: "The Dupoto Women's group make beaded items that include necklaces, bracelets, belts, coasters, baskets, earrings, traditional Maasai collars, cuffs and clothing. The money earned from the beadwork is used to send their daughters to school.",
        externalLinks: []
    },
    {
        href: "assets/files/motomoto.pdf",
        imgSrc: 'assets/img/press/Motomoto-Magazine.png',
        title: "Motomoto Magazine",
        description: "Motomoto magazine highlights how the women from the Maasai community participate in the women's based groups to help their daughters get an education.",
        externalLinks: []
    },
    {
        href: "assets/files/Bark.pdf",
        imgSrc: 'assets/img/press/Bark-Mag.png',
        title: "Bark Magazine",
        description: "The Bark magazine elaborates how the hand-beaded dog collars made by the Maasai women groups help send their daughters to school.",
        externalLinks: []
    },
    {
        href: "assets/files/National_Geographic.pdf",
        imgSrc: 'assets/img/press/NGA-Mag.jpg',
        title: "National Geographic Magazine (2005)",
        description: "The National Geographic Magazine, September 2005 edition. Special Issue: Africa. Features how Beads for Education, in collaboration with the Dupoto Women's Group, helps send their daughters to school.",
        externalLinks: []
    },
    {
        href: "assets/files/Lapidary_Journal.pdf",
        imgSrc: 'assets/img/press/Lapidary-Journal.png',
        title: "Lapidary Journal",
        description: "The Lapidary Journal magazine features how the Maasai make a variety of objects and vessels using wire and seed beads. The techniques used are simple and the results are stunning.",
        externalLinks: []
    },
];

export const mentorshipImages = [
    { src: 'assets/img/mentor/ment-1.JPG', alt: 'mentorship', description: 'Empowering children especially girls and women through mentorship programs.' },
    { src: 'assets/img/mentor/ment-3.JPG', alt: 'mentorship', description: 'Enabling girls to acquire the skills and knowledge necessary to lead independent and fulfilling lives.' },
    { src: 'assets/img/mentor/ment-2.JPG', alt: 'mentorship', description: 'Create lasting impact by transforming the lives of girl children and women, one bead at a time.' },
    { src: 'assets/img/mentor/ment-4.JPG', alt: 'mentorship', description: 'Empowering children especially girls and women through mentorship programs.' },
    { src: 'assets/img/mentor/ment-5.JPG', alt: 'mentorship', description: 'Enabling girls to acquire the skills and knowledge necessary to lead independent and fulfilling lives.' },
    { src: 'assets/img/mentor/ment-6.JPG', alt: 'mentorship', description: 'Create lasting impact by transforming the lives of girl children and women, one bead at a time.' },
    { src: 'assets/img/mentor/ment-10.JPG', alt: 'mentorship', description: 'Create lasting impact by transforming the lives of girl children and women, one bead at a time.' },
    { src: 'assets/img/mentor/ment-8.JPG', alt: 'mentorship', description: 'Empowering children especially girls and women through mentorship programs.' },
    { src: 'assets/img/mentor/ment-11.JPG', alt: 'mentorship', description: 'Create lasting impact by transforming the lives of girl children and women, one bead at a time.' },
];

export const beadingGroupsImages = [
    { src: 'assets/img/beadings/beadings1.png', alt: 'beading-groups', description: 'The Maasai tribe of Kenya is world-famous for its beautiful beadwork, which is created by the women of the tribe and worn in rituals and ceremonies by both men and women. It is often given as a gift on special occasions.' },
    { src: 'assets/img/beadings/beadings2.png', alt: 'beading-groups', description: 'Beadwork offers an important opportunity opportunity to Maasai women. Traditionally, they are uneducated, married at the age of 13, and completely financially reliant on the men or government aid. Their skills with beadwork are a chance for self-sufficiency.' },
    { src: 'assets/img/beadings/beadings3.png', alt: 'beading-groups', description: 'In 1993, the Dupoto Women`s Group was founded to give these omen some income, some security, and a way to provide a better life for their children. Since then, other groups have been established as well.' },
    { src: 'assets/img/beadings/beadings4.png', alt: 'beading-groups', description: 'The Dupoto Group consists of 25 Maasai women who hand-make all of the beaded items we sell. This is their primary source of income, and as a group they support more than 125 children.' },
    { src: 'assets/img/beadings/beadings5.png', alt: 'beading-groups', description: 'BEADS for Education supports the Women`s Beading Groups by marketing their products in the United States and Europe through volunteers and the BEADS website.' },
    { src: 'assets/img/beadings/beadings6.png', alt: 'beading-groups', description: 'Bead product purchases help these women and their families break a pattern of poverty.' },
];

export const changemakerProjects = [
    { src: 'assets/img/change/rebecca-award.jpg', backSrc: 'assets/img/change/rebeccas-book.png', alt: 'changemaking', description: 'Rebecca’s recognition certificate for publishing her award-winning book.' },
    { src: 'assets/img/change/wildlife-club.jpg', alt: 'changemaking', description: 'Rebecca (Center) leading others in a tree planting exercise.' },
    {
        src: 'assets/img/change/wildlife-club3.jpg',
        backSrc: 'assets/img/change/wildlife-club2.jpg',
        alt: 'changemaking',
        description: 'Tembea Girls High School Students Wildlife Club.'
    },
    { src: 'assets/img/change/changemaker.JPG', alt: 'changemaking', description: 'Students engage in the practical lessons of agriculture, nurturing the seeds of sustainability and self-sufficiency.' },
    { src: 'assets/img/change/changemaker2.JPG', alt: 'changemaking', description: 'A moment of pride and joy as students stand alongside their mentors, showcasing their certificates and the promising gateway to their bright futures.' },
    { src: 'assets/img/change/changemaker3.JPG', backSrc: 'assets/img/change/changemaker-b.JPG', alt: 'changemaking', description: 'Agriculture students with beaming smiles exhibit the fruits of their labor, holding up ripe fruits and vegetables as symbols of healthy living and agricultural education.' },
    { src: 'assets/img/change/changemaker4.JPG', backSrc: 'assets/img/change/changemaker4b.jpg', alt: 'changemaking', description: 'Construction of the Kling library that lay the groundwork for a structure that will stand as a beacon of learning and community development.' },
    { src: 'assets/img/change/changemaker5.jpg', alt: 'changemaking', description: 'A colorful display of literary love as students proudly hold their books aloft, symbolizing the nourishment of their minds and the vibrancy of education.' },
    { src: 'assets/img/change/Graduation.jpg', backSrc: 'assets/img/change/changemaker7.JPG', alt: 'changemaking', description: 'The triumphant celebration of success, as graduates in regal black gowns marking a rite of passage into a world of endless possibilities.' },
    { src: 'assets/img/change/changemaker9.jpg', backSrc: 'assets/img/change/changemaker9b.jpg', alt: 'changemaking', description: 'Crafting Futures; The joyful threading of dreams, as students engage with the hum of a sewing machine, stitching together not just fabric, but the tapestry of their potential careers.' },
    { src: 'assets/img/change/tembea-award.jpg', backSrc: 'assets/img/change/tembea-award-b.jpg', alt: 'changemaking', description: 'Accolade of Innovation; "Beads Tembea" awarded 2nd Place in the SWENext 2023 African Innovation Challenge on International Women`s Day.' },
    { src: 'assets/img/change/changemaker8.jpg', backSrc: 'assets/img/change/changemaker-8b.jpg', alt: 'changemaking', description: 'A collective effort for a brighter tomorrow, as beads students unite for a beach cleanup, ensuring their shores stay as pristine as their commitment to the environment.' },
]

export const libraryImages = [
    { src: 'assets/img/lib/group.jpg', alt: 'Kling-library', caption: 'Tembea BEADS High schools students class of 2020 pose before the Kling library.' },
    { src: 'assets/img/lib/lib9.JPG', alt: 'Kling-library', caption: 'This is just one of the many book shelves inside the Kling Library in Tembea Beads academy.' },
    { src: 'assets/img/lib/lib2.jpg', alt: 'Kling-library', caption: 'We are passionate about teaching girls to become readers.' },
    { src: 'assets/img/lib/lib3.jpg', alt: 'Kling-library', caption: 'Inspiring girls to love education and become lifelong learners.' },
    { src: 'assets/img/lib/lib4.jpg', alt: 'Kling-library', caption: 'The library is a place where students can go to read, study, and learn.' },
    { src: 'assets/img/lib/lib5.jpg', alt: 'Kling-library', caption: 'Girls are encouraged to read and learn about the world around them.' },
    { src: 'assets/img/lib/lib6.jpg', alt: 'Kling-library', caption: 'The library has a peaceful and quiet atmosphere.' },
    { src: 'assets/img/lib/lib7.jpg', alt: 'Kling-library', caption: 'The girls can read together and learn from each other.' },
    { src: 'assets/img/lib/lib8.jpg', alt: 'Kling-library', caption: 'The girls in the library are engaged in learning and teaching each other.' },
    { src: 'assets/img/lib/lib10.JPG', alt: 'Kling-library', caption: 'Little kids practicing their reading skills in the library.' },
    { src: 'assets/img/lib/lib11.JPG', alt: 'Kling-library', caption: 'The kids can read together and learn from each other.' },
    { src: 'assets/img/lib/lib12.JPG', alt: 'Kling-library', caption: 'Through groups reading, the kids are able to learn from each other.' },
    { src: 'assets/img/lib/lib13.jpg', alt: 'Kling-library', caption: 'Earlier construction of the Kling library.' },
    { src: 'assets/img/lib/lib14.jpg', alt: 'Kling-library', caption: 'Roofing placement and construction of the Kling library.' },
    { src: 'assets/img/lib/lib15.jpg', alt: 'Kling-library', caption: 'At the beginning of the construction of the Kling library.' },
];

export const internImages = [
    { src: 'assets/img/intern/IP4.JPG', alt: 'interns', description: 'Every year, a number of BEADS-sponsored girls graduate from high school. Before receiving continued support in college, they spend one year working as BEADS interns.' },
    { src: 'assets/img/intern/IP1.JPG', alt: 'interns', description: 'BEADS interns serving porridge to the nursery school pupils.' },
    { src: 'assets/img/intern/IP2.jpg', alt: 'interns', description: 'A BEADS intern inside the classroom teaching nursery school pupils.' },
    { src: 'assets/img/intern/IP3.JPG', alt: 'interns', description: 'A group of nursery pupils who are taught by the BEADS interns are reading books outside their classroom.' },
    { src: 'assets/img/intern/IP7.JPG', alt: 'interns', description: 'In one of the schools, a teaching intern instructs some young students in basic arithmetic.' },
    { src: 'assets/img/intern/IP6.JPG', alt: 'interns', description: 'In one of the schools, a teaching intern instructs some young students in basic arithmetic.' },
    { src: 'assets/img/intern/IP10.JPG', alt: 'interns', description: 'BEADS interns work as teachers and librarians in remote schools, and they provide environmental education, adult literacy and mentoring to younger girls.' },
    { src: 'assets/img/intern/IP5.JPG', alt: 'interns', description: 'An intern teaching a literacy course at Lobarishareki Primary School.' },
    { src: 'assets/img/intern/IP8.JPG', alt: 'interns', description: 'Interns serving students meals during lunch break at the school dinnings.' },
    { src: 'assets/img/intern/IP9.jpg', alt: 'interns', description: 'BEADS interns helping in Tembea Greenhouse project.' },
    { src: 'assets/img/about/Intern-5.png', alt: 'interns', description: 'During term break, each girl develops her own volunteer project in her home region. Girls often teach HIV-AIDS awareness, work in the local clinic, provide adult literacy tutoring and more.' },
    { src: 'assets/img/about/Intern-7.png', alt: 'interns', description: 'Successful interns continue to college and university in Kenya. After graduation, they will marry a man of their choice and begin their careers in pharmacy, teaching, accounting, etc. One of our college graduates is the BEADS program manager.' },
    // { src: 'assets/img/about/Intern-6.png', alt:'interns', description: 'Libraries are a rare, precious resource in rural Kenya. BEADS Interns do everything from cataloging new arrivals to leading book clubs to giving lessons on research. Here, interns Diana and Carolyn unpack and catalog a new shipment of sponsor-donated books.' },
];

export const comingOfAgeData = [
    { src: 'assets/img/ComingOfAge/coming-1.png', alt: 'coming-of-age', description: 'In her early teenage years, a young Maasai girl has her Coming of Age ceremony, an important ritual where she becomes a woman. Until recently, the ceremony has included Female Genital Mutilation -- a practice that would scar her for life. Although FGM is illegal in Kenya, the laws are rarely enforced.' },
    { src: 'assets/img/ComingOfAge/coming-2.png', alt: 'coming-of-age', description: 'BEADS for Education is committed to helping the Maasai eliminate the cutting, while respectfully supporting their traditions. Our alternative rite of passage was developed by the Maasai leaders themselves.' },
    { src: 'assets/img/ComingOfAge/coming-3.png', alt: 'coming-of-age', description: 'BEADS funded Patrick Papatiti, a Maasai leader of more than 8,000 warriors in the Amboseli region, to research the practice of FGM. He concluded that FGM was wrong, and that an alternative ceremony could be developed.' },
    { src: 'assets/img/ComingOfAge/coming-4.png', alt: 'coming-of-age', description: 'Since 2005, BEADS has been helping to host several alternative ceremonies each year, such as the one shown here. The ceremony remains appropriately traditional, and the result is just as meaningful to all involved.' },
    { src: 'assets/img/ComingOfAge/coming-5.png', alt: 'coming-of-age', description: 'Mama Esther (the local midwife and circumciser) held the first BEADS Coming of Age ceremony WITHOUT THE CUT for her daughter, Esther. Mama Esther said, This is important to us and Esthers sponsors.' },
    { src: 'assets/img/ComingOfAge/coming-6.png', alt: 'coming-of-age', description: 'Every ceremony without the cut shows the community that the rite can be just as meaningful without FGM. Here, relatives of an initiate show their support.' },
    { src: 'assets/img/ComingOfAge/coming-7.png', alt: 'coming-of-age', description: 'Through BEADS support, thousands of people have been educated about the negative impact of FGM.' },
    { src: 'assets/img/ComingOfAge/coming-8.png', alt: 'coming-of-age', description: 'Your support can help provide acceptable alternative rituals, and give girls the chance to enter womanhood in a healthy, happy way -- without the cut.' },
];

export const teacherTrainingData = [
    { src: 'assets/img/t-training/tt-1.png', alt: 'Teacher-Training', description: 'BEADS strives to improve the quality of teaching in our sponsored schools with our teacher training and intern program. Most teaching in Kenya is based on memorization and repetition. Our goal is to create critical thinkers and ultimately the next generation of Kenyan leaders.' },
    { src: 'assets/img/t-training/tt-2.png', alt: 'Teacher-Training', description: 'Our interactive teaching, reading and writing programs are unique in Kenya.' },
    { src: 'assets/img/t-training/tt-3.png', alt: 'Teacher-Training', description: 'Programs include an extensive book club program where all of our students and teachers read and discuss the same books. Every student will read and discuss 64 classic books before they graduate from 8th grade.' },
    { src: 'assets/img/t-training/tt-4.png', alt: 'Teacher-Training', description: 'Most Kenyan schools don`t have the resources to teach hands-on lessons. BEADS does its best to help teachers make lessons more compelling, memorable and fun.' },
    { src: 'assets/img/t-training/tt-5.png', alt: 'Teacher-Training', description: 'Environment education includes a course in the local environment and conservation. One of our newest programs is our town clean up and recycling program -- students make toys for the younger students and displays for the school with recyclables they collect!' },
    { src: 'assets/img/t-training/tt-6.png', alt: 'Teacher-Training', description: 'Perhaps the best form of teacher training is the BEADS Interns program. Several of our sponsored girls have expressed an interest in becoming full-time teachers after graduation.' },
];

export const schoolSponsorshipImages = [
    { src: 'assets/img/s-scholarship/ss-1.png', alt: 'school-sponsor', description: 'Most traditional Kenyan families cannot afford to pay school tuition fees for their daughters. A young Kenyan girl who remains uneducated risks a future filled with illiteracy, poor health, poverty and oppression.' },
    { src: 'assets/img/s-scholarship/ss-2.png', alt: 'school-sponsor', description: 'Sponsoring a girl`s education will make a huge difference in her life, and it will directly help future generations of her family.' },
    { src: 'assets/img/s-scholarship/ss-3.png', alt: 'school-sponsor', description: 'Since 1998 BEADS for Education has sponsored the schooling of more than 320 girls thanks to people like you who have become BEADS sponsors.' },
    { src: 'assets/img/s-scholarship/ss-4.png', alt: 'school-sponsor', description: 'Sponsorships begin in elementary school and can continue through college.' },
    { src: 'assets/img/s-scholarship/ss-5.png', alt: 'school-sponsor', description: 'The girls come from several different tribes, but most are Maasai.' },
    { src: 'assets/img/s-scholarship/ss-6.png', alt: 'school-sponsor', description: 'Girls are required to maintain satisfactory grades, attend workshops, and provide school reports. The girls also communicate regularly with their sponsors, and many have made lifelong friendships.' },
    { src: 'assets/img/s-scholarship/ss-7.png', alt: 'school-sponsor', description: 'After high school, each girl works as a teaching intern for one year in a remote, public school, assisting in the educations of even more young girls. When she has successfully completed her BEADS internship, she is eligible to continue to college through her BEADS sponsorship.' },
    { src: 'assets/img/s-scholarship/ss-8.png', alt: 'school-sponsor', description: 'It is no exaggeration to say that your sponsorship, though it starts with one girl, helps to change the entire world. If you would like to sponsor a girl, please contact Debby Rooney today.' },
];

export const famineReliefData = [
    { src: 'assets/img/f-relief/fr-1.png', alt: 'famine-relief', description: 'There have been two devastating droughts in Kenya in the last decade alone. Droughts especially affect tribes like the Maasai, who are pastoralist herders who rely on grazing land for their animals. The effects of one season of drought can be felt for as many as five years as the herds are rebuilt.' },
    { src: 'assets/img/f-relief/fr-2.png', alt: 'famine-relief', description: 'When people are starving, it`s hard for kids to go to school and study. As a committed member of the community, BEADS mobilizes its resources to help.' },
    { src: 'assets/img/f-relief/fr-3.png', alt: 'famine-relief', description: 'In addition to distributing food, BEADS teaches alternative food-sourcing techniques so that local people will be better prepared for the next drought.' },
    { src: 'assets/img/f-relief/fr-4.png', alt: 'famine-relief', description: 'In 2006, BEADS` efforts were able to feed more than 7,000 hungry people for a month.' },
    { src: 'assets/img/f-relief/fr-5.png', alt: 'famine-relief', description: 'In 2009 - 2010, BEADS distributed more than $100,000 USD of food to drought-affected areas.' },
    { src: 'assets/img/f-relief/fr-6.png', alt: 'famine-relief', description: 'In semi-arid Kenya, droughts can be expected to happen again, probably sooner rather than later. When they do, BEADS will respond with more relief efforts for the communities we have become a part of.' },
];

export const successStories = [
    {
        title: "BEADS' sponsored Beryl (Bachelor in Communication and Media with IT)",
        image: 'assets/img/success-stories/Beads-Beryl.png',
        alt: 'beryl-image',
        link: '/success-stories',
        date: '20-02-2022',
    },
    {
        title: "The Maasai Changemaker: Rebecca's Changemaker Journey",
        image: 'assets/img/success-stories/Rebecca-change.jpg',
        alt: 'rebeca-image',
        link: '/success-stories',
        date: '01-04-2020',
    },
    {
        title: 'Beads sponsored SANAIPEI LOLKINYIEI to complete her education successfully.',
        image: 'assets/img/success-stories/Sanaipei-success.jpeg',
        alt: 'sanaipei-image',
        link: '/success-stories',
        date: '01-12-2016',
    }
];

export const successStoriesMain = [
    {
        src: 'assets/img/success-stories/Ann-wambua.jpg',
        alt: 'success-stories',
        title: 'ANN WAMBUI - A GEOLOGIST',
        description: ' Ann Wambui #9 proudly stands with her husband and two children. She graduated from college in 2014 with a B.S. in geology. She worked with a major geotechnical firm as a lead geologist determining the safety of a building on a plot of land. She just opened her own geotechnical firm. “My mother was the best tea picker in Kenya, but she did not earn enough money to support us. She had to send me to live with a guardian. I graduated top of my class in 8th grade. Everyone was so happy for me BUT I was so sad. I cried many nights because I had no hope of going to high school. Then a miracle happened. I received a BEADS sponsorship and I sang with joy. . If it were not for BEADS I would have been married off as young as 13 into a life of poverty”, Ann reminisces.'
    },
    {
        src: 'assets/img/success-stories/Reachaele.jpeg',
        alt: 'success-stories',
        title: 'RACHAEL E. MSOKA - A DOCTOR',
        description: 'I am Rachael E. Msoka, and have just graduated with a Bachelor of Medicine from the University of Nairobi. I am from a Tanzanian and have 4 siblings but I am the only one who got a chance to access good education. When my father died on a road accident, I was very young. My mother could not support the whole family and my aunt offered to take me with her to Kenya. One of my sisters ended up marrying at a tender age and our third born later did the same. Ours was a struggle to make ends meet.'
    },
    {
        src: 'assets/img/success-stories/Leyian.jpeg',
        alt: 'success-stories',
        title: 'LEYIAN METEINE',
        description: 'Hope that this New Year is wonderful for you, your family and friends. We have just celebrated our third graduating class from Tembea Academy. Twenty seven girls graduated and many sponsors joined us for the celebration. Sponsors usually spend several days after graduation volunteering. Everyone can help from reading to our nursery students to teaching internet skills. Sponsors often continue with a safari. We hope that you will join us next January for this once in a lifetime experience.'
    },
    {
        src: 'assets/img/success-stories/Florence.png',
        alt: 'success-stories',
        title: 'SINET FLORENCE NASOORE',
        description: 'Hope that this New Year is wonderful for you, your family and friends. We have just celebrated our third graduating class from Tembea Academy. Twenty seven girls graduated and many sponsors joined us for the celebration. Sponsors usually spend several days after graduation volunteering. Everyone can help from reading to our nursery students to teaching internet skills. Sponsors often continue with a safari. We hope that you will join us next January for this once in a lifetime experience.'
    },
    {
        src: 'assets/img/success-stories/Sanaipei-success.jpeg',
        alt: 'success-stories',
        title: 'SANAIPEI LOLKINYIEI',
        description: 'Hope that this New Year is wonderful for you, your family and friends. We have just celebrated our third graduating class from Tembea Academy. Twenty seven girls graduated and many sponsors joined us for the celebration. Sponsors usually spend several days after graduation volunteering. Everyone can help from reading to our nursery students to teaching internet skills. Sponsors often continue with a safari. We hope that you will join us next January for this once in a lifetime experience.'
    },
    {
        src: 'assets/img/success-stories/Flo-maina.png',
        alt: 'success-stories',
        title: 'SANAIPEI LOLKINYIEI',
        description: 'Hope that this New Year is wonderful for you, your family and friends. We have just celebrated our third graduating class from Tembea Academy. Twenty seven girls graduated and many sponsors joined us for the celebration. Sponsors usually spend several days after graduation volunteering. Everyone can help from reading to our nursery students to teaching internet skills. Sponsors often continue with a safari. We hope that you will join us next January for this once in a lifetime experience.'
    },
];

export const sponsorsImages = [
    { src: 'assets/img/sponsors/sponsor-trip.jpeg', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor1.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor2.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor4.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor5.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor6.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor7.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor9.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor10.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor11.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
    { src: 'assets/img/sponsors/sponsor12.JPG', alt: 'sponsors', description: 'Every year, a number of BEADS- Sponsors come to visit our schools and the girls in Kenya.' },
];

export const donateImages = [
    { src: 'assets/img/donate/donate.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate2.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate3.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate4.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate5.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate6.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate7.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate8.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate9.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate10.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate11.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate12.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate13.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate14.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate15.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate16.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate17.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate18.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate19.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate20.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate21.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate22.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate23.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate24.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate25.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate26.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate27.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate28.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate29.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate30.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate31.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate32.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate33.jpg', alt: 'donate', },
    { src: 'assets/img/donate/donate34.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate35.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate36.JPG', alt: 'donate', },
    { src: 'assets/img/donate/donate37.JPG', alt: 'donate', },
];

export const newsDetails = [
    {
        id: '000',
        category: 'Featured News',
        title: 'Featured in Other News',
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'text',
                // text: 'This paragraph includes an external [link](http://example.com) and is styled with *italics*.',
                text: 'We hope that this email  finds you and your family well during these challenging times.  Please  stay safe. I am still in Kenya and my flight home has been cancelled. I  miss home but am enjoying the beauty of the school and the work we are  accomplishing.',
                style: {},
            },
            {
                type: 'text',
                text: 'I am pleased to tell you  that none of our 21 staff have been furloughed and we continue to pay  their salaries, social security and health insurance.  And, of course,  this enables them to support their families.  They are very grateful.',
                style: {},
            },
            {
                type: 'text',
                text: 'I am pleased to tell you  that none of our 21 staff have been furloughed and we continue to pay  their salaries, social security and health insurance.  And, of course,  this enables them to support their families.  They are very grateful.',
                style: {},
            },
            {
                type: 'text',
                text: 'Our online classes are  working very well. The teachers and students have a normal school time  table for the day from 9 A.M. until 4 P.M. The girls are learning and  submitting their work for marking. We are pleased with our success as  most schools are not. Many of our college students are also doing online  classes. Below see our online learning link of how the program works.',
                style: {},
            },
            {
                type: 'text',
                text: 'Our school curriculum  focuses on creative and critical thinking, leadership training and each  girls commitment to design a project to address problems in her  community.  Rebecca, 11th grade, started a project on environmental  protection. Her Member of Parliament promised to represent her petition  to the national government.  She was honored as an Ashoka Changemaker  and published in several articles.',
                style: {},
            },
            {
                type: 'text',
                text: '540 Sharlyne and 202 Rebecca have been selected for this year"s Yale Young African Scholar conference to be held next month.',
                style: {},
            },
            {
                type: 'text',
                text: 'BEADS has been featured in  various newsletters including African Elephant Research, Ashoka, Segal  Family Foundation and HundrED all with great visibility and the  opportunity to reach more sponsors for our girls.',
                style: {},
            },
            {
                type: 'list',
                items: [
                    'HundRED.org has also published three of our innovations which you can see in these links :',
                    'online learning in remote areas, [hundred](https://hundred.org/en/innovations/online-learning-in-remote-areas)',
                    'Every girl a changemaker, [hundred](https://hundred.org/en/innovations/every-girl-a-changemaker)',
                    'and Develop Creative and Critical Thinking. [hundred](https://hundred.org/en/innovations/develop-creative-and-critical-thinking)',
                    'Our teacher Magaga has become the HundrED ambassador for Kenya: [hundred](https://hundred.org/en/users/enos-magaga)',
                    'Three of our students are also competing for the HundRED youth ambassador, Kenya.',
                ],
                style: { fontStyle: 'italic' },
            },
            {
                type: 'text',
                text: 'We have updated our website, Facebook and Instagram. Join us to get more updates.',
                style: {},
            },
            {
                type: 'text',
                text: 'At school, we are working  on maintenance by painting dormitories, classrooms, library, kitchen and  the dining hall. Hundreds of windows were painstakingly painted.',
                style: {},
            },
            {
                type: 'text',
                text: 'Although the girls are not here, we are taking care of their goats for the agriculture curriculum project. ',
                style: {},
            },
            {
                type: 'text',
                text: 'At school, we are working  on maintenance by painting dormitories, classrooms, library, kitchen and  the dining hall. Hundreds of windows were painstakingly painted.',
                style: {},
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713334/Beads/news/Beads-concern_hb5t1a.jpg',
                alt: 'Painting-classrooms',
                description: 'Painting classrooms.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713334/Beads/news/Beads-concern2_yxqzps.jpg',
                alt: 'Girls inoculate goats',
                description: 'Girls inoculate goats.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713335/Beads/news/Beads-concern3_bwhnoa.jpg',
                alt: 'Sunflowers from our garden',
                description: 'Sunflowers from our garden.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713335/Beads/news/Beads-concern4_idlm7b.jpg',
                alt: 'broccoli-harvest-from-garden',
                description: 'Our gardener Rajab holding broccoli harvest from the garden.',
            },
            {
                type: 'text',
                text: 'Guidestar, the organization that rates non- profits has upgraded our status from bronze star to silver star and now gold star.',
                style: { fontStyle: 'italic' },
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851710/Beads/news/gold_Star_obbbw3.png',
                alt: 'Guidestar',
                description: 'Beads for Education, Inc. at Gold Level.',
            },
            {
                type: 'text',
                text: 'Thank you for your continued generous support and helping us to change lives, one girl at a time.  Stay safe! ',
                style: { fontStyle: 'italic' },
            },
            {
                type: 'quote',
                text: "Here's a memorable quote from the article.",
                cite: "Author Name",
            },
            {
                type: 'list',
                items: [
                    'First item in a list',
                    'Second item with a link to [OpenAI](https://openai.com)',
                    'Third item',
                ],
            },
            {
                type: 'paragraph',
                text: 'A paragraph with **bold** text, and supporting *italic* text.',
            },
            // Add more content objects as needed
        ],
        date: '02-06-2021',
        author: 'Debbie',
    },
    // Additional news items...
];

export const recentNewsData = [
    {
        id: '001',
        category: 'Featured News',
        title: 'Featured in HundrED, Segal Family Foundation, Guidestar and Ashoka Changemakers',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907268/Beads/news/banner_gmfyyr.jpg',
            alt: 'Featured',
            description: 'Featured in Other News',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'text',
                text: 'We hope that this email  finds you and your family well during these challenging times.  Please  stay safe. I am still in Kenya and my flight home has been cancelled. I  miss home but am enjoying the beauty of the school and the work we are  accomplishing.',
                style: {},
            },
            {
                type: 'text',
                text: 'I am pleased to tell you  that none of our 21 staff have been furloughed and we continue to pay  their salaries, social security and health insurance.  And, of course,  this enables them to support their families.  They are very grateful.',
                style: {},
            },
            {
                type: 'text',
                text: 'I am pleased to tell you  that none of our 21 staff have been furloughed and we continue to pay  their salaries, social security and health insurance.  And, of course,  this enables them to support their families.  They are very grateful.',
                style: {},
            },
            {
                type: 'text',
                text: 'Our online classes are  working very well. The teachers and students have a normal school time  table for the day from 9 A.M. until 4 P.M. The girls are learning and  submitting their work for marking. We are pleased with our success as  most schools are not. Many of our college students are also doing online  classes. Below see our online learning link of how the program works.',
                style: {},
            },
            {
                type: 'text',
                text: 'Our school curriculum  focuses on creative and critical thinking, leadership training and each  girls commitment to design a project to address problems in her  community.  Rebecca, 11th grade, started a project on environmental  protection. Her Member of Parliament promised to represent her petition  to the national government.  She was honored as an Ashoka Changemaker  and published in several articles.',
                style: {},
            },
            {
                type: 'text',
                text: '540 Sharlyne and 202 Rebecca have been selected for this year"s Yale Young African Scholar conference to be held next month.',
                style: {},
            },
            {
                type: 'text',
                text: 'BEADS has been featured in  various newsletters including African Elephant Research, Ashoka, Segal  Family Foundation and HundrED all with great visibility and the  opportunity to reach more sponsors for our girls.',
                style: {},
            },
            {
                type: 'text',
                text: 'HundRED.org has also published three of our innovations which you can see in these links:',
                style: {},
            },
            {
                type: 'list',
                items: [
                    { text: 'Online learning in remote areas', url: 'https://hundred.org/en/innovations/online-learning-in-remote-areas' },
                    { text: 'Every girl a changemaker', url: 'https://hundred.org/en/innovations/every-girl-a-changemaker' },
                    { text: 'Develop Creative and Critical Thinking', url: 'https://hundred.org/en/innovations/develop-creative-and-critical-thinking' },
                    { text: 'Our teacher Magaga has become the HundrED ambassador for Kenya', url: 'https://hundred.org/en/users/enos-magaga' },
                ],
            },
            {
                type: 'text',
                text: 'Three of our students are also competing for the HundRED youth ambassador, Kenya.',
                style: {},
            },
            {
                type: 'text',
                text: 'We have updated our website, Facebook and Instagram. Join us to get more updates.',
                style: {},
            },
            {
                type: 'text',
                text: 'At school, we are working  on maintenance by painting dormitories, classrooms, library, kitchen and  the dining hall. Hundreds of windows were painstakingly painted.',
                style: {},
            },
            {
                type: 'text',
                text: 'Although the girls are not here, we are taking care of their goats for the agriculture curriculum project. ',
                style: {},
            },
            {
                type: 'text',
                text: 'At school, we are working  on maintenance by painting dormitories, classrooms, library, kitchen and  the dining hall. Hundreds of windows were painstakingly painted.',
                style: {},
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713334/Beads/news/Beads-concern_hb5t1a.jpg',
                alt: 'Painting-classrooms',
                description: 'Painting classrooms.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713334/Beads/news/Beads-concern2_yxqzps.jpg',
                alt: 'Girls inoculate goats',
                description: 'Girls inoculate goats.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713335/Beads/news/Beads-concern3_bwhnoa.jpg',
                alt: 'Sunflowers from our garden',
                description: 'Sunflowers from our garden.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713335/Beads/news/Beads-concern4_idlm7b.jpg',
                alt: 'broccoli-harvest-from-garden',
                description: 'Our gardener Rajab holding broccoli harvest from the garden.',
            },
            {
                type: 'text',
                text: 'Guidestar, the organization that rates non- profits has upgraded our status from bronze star to silver star and now gold star.',
                style: { fontStyle: 'italic' },
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851710/Beads/news/gold_Star_obbbw3.png',
                alt: 'Guidestar',
                description: 'Beads for Education, Inc. at Gold Level.',
                style: { widht: '20%', height: '10%' },
            },
            {
                type: 'text',
                text: 'Thank you for your continued generous support and helping us to change lives, one girl at a time.  Stay safe! ',
                style: { fontStyle: 'italic' },
            },
        ],
        date: '02-06-2021',
        author: 'Debbie',
    },
    {
        id: '002',
        category: 'Recent News',
        title: 'Kenyan girls from BEADS selected by YALE Young African Scholars',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907530/Beads/news/Yale-Young-African-Scholars2_tzx1i9.png',
            alt: 'YALE',
            description: 'YALE Young African Scholars',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'It is our prayer that you are all doing fine despite what is going  on in the whole world. Please stay safe, take care of yourself and your  loved ones. This too shall pass. Here is a good excerpt from a poem to cheer you up from our form 4 students "Oh! the Places You will Go" by Dr. Seuss.',
                    },
                    {
                        type: 'video',
                        embedUrl: 'https://www.youtube.com/embed/ATFKtEyxpSY',
                        description: 'Tembea Academy 12th Grade Girls Recite',
                    },
                    {
                        type: 'text',
                        text: 'Beads for Education: Oh! the Places You will Go!',
                    },
                    {
                        type: 'text',
                        text: 'To some good news this month: two of our girls Rebecca, 11th grade  and Sharline, 12th grade got admission to the 2020 Yale Young African  Scholars(YYAS). They were chosen to represent Kenya among applicants  from 40 countries in Africa and travel to Ghana, in West Africa, for a  workshop, meet the other like minded youths who wish to make meaningful  impact as young leaders on the continent and share ideas.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851172/Beads/news/Rebbecca-Yale_gekwfx.jpg',
                        alt: 'Rebecca-Naisimoi',
                        description: '#202 Rebecca Naisimoi',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851172/Beads/news/Yale_cmozyv.jpg',
                        alt: 'Rebeca-YYAS',
                        description: 'Rebeca Admision to Yale Young African  Scholars(YYAS)',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851171/Beads/news/Sharline-Yale_joa7zj.jpg',
                        alt: 'Sharline-Wambui',
                        description: 'Sharline Wambui #540',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851173/Beads/news/Yale2_s4xcgc.jpg',
                        alt: 'Sharline-Wambui',
                        description: 'Sharline Admision to Yale Young African  Scholars(YYAS)',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you for your continued generous support. Stay safe! ',
            },
        ],
        date: '01-04-2020',
        author: 'Debbie',
    },
    {
        id: '003',
        category: 'Community Development',
        title: 'Maasai girls’ sponsorship Update Term 1 2020',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907698/Beads/news/masai-sponsorship_n7bxrj.jpg',
            alt: 'Maasai-girls',
            description: 'Maasai girls’ sponsorship',
        },
        content: [
            {
                type: 'text',
                text: 'Supporting women education in Kenya, Africa. ',
            },
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'I have been working at our high school in Kenya since September and enjoying every day teaching. We have 100 girls in classes 9 through 12. Another 15 girls were rescued from the Masai Mara from forced early marriage and circumcision by bringing them to our high school.  This brings our total of rescued girls in the past three years to 45.  Ten girls are working at our nursery school as teachers during their gap year and before they enroll in college.  Thirty five young women are attending college through your generous support. ',
                    },
                    {
                        type: 'text',
                        text: 'If you have friends that would like to sponsor a girl, please let me know as we need many more sponsors.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707901409/Beads/news/maasai-girls_wpthkr.jpg',
                        alt: 'Maasai-girls',
                        description: 'Maasai girls joinign Tembea High School',
                    },
                    {
                        type: 'text',
                        text: 'The Mara parents are very poor and the girls arrive at school with nothing.  Above the girls receive their boarding supplies and uniforms from our generous sponsors.',
                    },
                    {
                        type: 'text',
                        text: 'Grace has just graduated from our BEADS High School and is now interning as a teacher at our nursery school.  After successfully completing her internship, she will enroll in the university to study agronomy.  She wants to help the poor grow their own food so that no child will go to bed hungry as she did so many times.  Grace was born in the Kibera slums – the largest slum in Africa. “My mother struggled and fought to feed and educate me and my 3 sisters and 2 brothers.  I never thought I would be able to attend high school due to school fees.  I expected to be married off to a much older man who I had never met or to become a housemaid in a rich man’s house.  In 8th grade, I almost lost all hope. I thought it was a miracle when I was sponsored to join the BEADS High School. I knew my life would change completely.  The stars never shone like this before. Education is the key the key to success,” Grace wrote in her journal.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707901398/Beads/news/Grace_sqhbh3.jpg',
                        alt: 'Grace',
                        description: 'Grace is studying agronomy.',
                    },
                    {
                        type: 'text',
                        text: 'Every year we celebrate all the tribes that attend our school.  This year we have 6 tribes of the 42 in Kenya -   Maasai, Kamba, Luo, Kisii, Digo and Kikuyu. Each tribe builds their traditional hut and greets the other tribes with a welcoming song, an explanation of their hut, how their people live and earn money, a traditional song and closing with their prayer. We do this to counter tribalism which has been rampant in Kenya in many of the past elections.  We continue with a class unit which focuses on genocide in other countries e.g. Rwanda, Kenya, and Germany. This year the unit culminated with a guest speaker who escaped the Hutu and Tutsi genocide in Rwanda.',
                    },
                    {
                        type: 'text',
                        text: 'In academics we continue to improve our scores on the national tests.  Speaking only English at school and having bookclubs weekly are the greatest influence for our academic performance.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707901397/Beads/news/Debby-and-girls_h981ro.jpg',
                        alt: 'Debbie-and-girls',
                        description: '(from left) Elizabeth, Debby, Crystal and Grace.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '01-04-2020',
        author: 'Auditor',
    },
    {
        id: '004',
        category: 'Success Stories',
        title: 'Winter 2019',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907268/Beads/news/1_rtdldf.jpg',
            alt: 'Beads',
            description: 'Winter 2019',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'Hope that this New Year is wonderful for you, your family and friends. We have just celebrated our third graduating class from Tembea Academy. Twenty seven girls graduated and many sponsors joined us for the celebration. Sponsors usually spend several days after graduation volunteering. Everyone can help from reading to our nursery students to teaching internet skills. Sponsors often continue with a safari. We hope that you will join us next January for this once in a lifetime experience. ',
                    },
                    {
                        type: 'text',
                        text: 'All our high school graduates spend one year giving back to their communities. They work as teachers in our primary school before they are eligible to attend college with your very generous sponsorship.  Our girls are studying teaching, geology, project management, internet technology, and nursing to name a few majors.  Our goal is to prepare our girls to be successful young women, critical thinkers, with a strong character and commitment to their families, communities and the nation.',
                    },
                    {
                        type: 'text',
                        text: 'Four of our graduates work at our high school as teachers and another one is our accountant.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/Diana-winter_da77cx.jpg',
                        alt: 'Diana',
                        description: 'Diana featured in Kenya’s Daily Nation newspaper, 2006.',
                    },
                    {
                        type: 'text',
                        text: 'Diana #212 began her sponsorship in 2003 in 6th grade. Shortly after she was featured in Kenya’s Daily Nation newspaper raising awareness for girls’ education.  She attained her B.S. in mathematics at Kenyatta University, Nairobi, Kenya.  Now, she teaches math and business at Tembea Academy. She is also our photographer and Director of Communications.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/Diana-family_nk0ki7.jpg',
                        alt: 'Diana-family',
                        description: 'Diana and her daughter Nikky',
                    },
                    {
                        type: 'text',
                        text: 'She is married, selected her own husband and has one adorable little girl.  Diana says, “I come from a humble background with many siblings. If it were not for Beads, I would have been married off at a tender age, live in the village forever and never achieve my dreams to be a person of substance for my community. I am eternally grateful to Beads for Education."',
                    },
                    {
                        type: 'text',
                        text: 'Ann Wambui  #9 proudly stands with her husband and two children. She graduated from college in 2014 with a B.S. in geology.  She worked with a major geotechnical  firm as a lead geologist determining the safety of a building on a plot of land. She just opened her own geotechnical firm. “My mother was the best tea picker in Kenya, but she did not earn enough money to support us. She had to send me to live with a guardian. I graduated top of my class in 8th grade. Everyone was so happy for me BUT I was so sad. I cried many nights because I had no hope of going to high school.  Then a miracle happened.  I received a BEADS sponsorship and I sang with joy. . If it were not for BEADS I would have been married off as young as 13 into a life of poverty”, Ann reminisces.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/Ann-wambui-family_tcaxbq.jpg',
                        alt: 'Ann-Wambui',
                        description: 'Ann Wambui’s family.',
                    },
                    {
                        type: 'text',
                        text: 'Florence Ekuri # 11 pictured in her Kenya Wildlife Service uniform. She is studying to be a field guide and will be one of the few Kenyan women in this field.  Her sponsorship in 9th grade rescued her from the war torn regions of Kenya. She lost her family during this war and arrived on our doorstep with a determination to receive an education.  We are so proud of her and know that she will have a successful  life.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/florence-kws_eskdya.jpg',
                        alt: 'Florence',
                        description: 'Florence in her KWS Uniform.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '01-04-2019',
        author: 'Debby Rooney -BEADS Cofounder',
    },
    {
        id: '005',
        category: 'Beads Graduation',
        title: 'Tembea High School Graduation',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/Graduation_mxmbmk.jpg',
            alt: 'Graduation',
            description: 'Tembea High School Graduation.',
        },
        content: [
            {
                type: 'text',
                text: 'This also marks the 10th Anniversary for Beads Tembea Academy, a school established by BEADS for Education in the year 2013 to provide quality education and critical thinking skills.',
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/Graduation_mxmbmk.jpg',
                        alt: 'Graduation',
                        description: 'Tembea High School Graduation.',
                    },
                    {
                        type: 'text',
                        text: 'On January 2017, BEADS sponsors traveled to Tembea High School to attend the graduation ceremony of the first class of students to attend Tembea all four years. The sponsors were greeted with welcoming songs and got to meet the girls`families. Some sponsors traveled to visit the girls` families in their homes. It was a joyful occasion and everyone is very proud of the Tembea graduates. ',
                    },
                    {
                        type: 'text',
                        text: 'Here`s the attached video clip of the event;',
                    },
                    {
                        type: 'video',
                        embedUrl: 'https://www.youtube.com/embed/2LI7wGr-Tlo',
                        description: 'Tembea Academy 2017 Graduation',
                    },
                    {
                        type: 'text',
                        text: 'The graduates are now interning as teachers at our primary school before they are eligible to enter college.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/Graduation3_svj7hr.jpg',
                        alt: 'Graduation',
                        description: '2017 TEMBEA ACADEMY GRADUATES.',
                    },
                    {
                        type: 'text',
                        text: ' Fifty of our sponsored graduates are now attending colleges studying to be nurses, accountants, teachers, and a chemical engineer among other majors. ',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707906708/Beads/news/grad-interns_dlelvu.jpg',
                        alt: 'Graduation',
                        description: '2017 TEMBEA ACADEMY GRADUATES.',
                    },
                    {
                        type: 'text',
                        text: 'ALL of these girls need sponsors to continue their education and I hope you will share this with your friends. Together we ARE changing girls’ lives – one girl at a time.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904882/Beads/news/Graduation2_esnsqh.jpg',
                        alt: 'Graduation',
                        description: '2017 TEMBEA ACADEMY GRADUATES.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '20-12-2023',
        author: 'Auditor',
    },
    {
        id: '006',
        category: 'Success Stories',
        title: '2019 TERM 2 SPONSOR NEWSLETTER',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907272/Beads/news/mentor_ybe64u.jpg',
            alt: 'Beads',
            description: '2019 TERM 2 SPONSOR NEWSLETTER',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'I hope that you are having a great summer.  This was a very successful term for our girls at Tembea Academy.',
                    },
                    {
                        type: 'text',
                        text: 'We strive to provide quality education and teach our girls “to think”. We enrich the Kenyan curriculum and teaching methodology.  One of our key components is an extensive reading and book club program. In the Kenyan curriculum, students read only 2 books in 11th grade and 2 books in 12th grade.',
                    },
                    {
                        type: 'text',
                        text: 'Our girls read about 14 books a year.  Our book club program includes many classics including:',
                    },
                    {
                        type: 'list',
                        items: [
                            { text: 'The Good Earth,' },
                            { text: 'Harry Potter,' },
                            { text: 'Little House on the Prairie,' },
                            { text: 'Charlotte’s Web,' },
                            { text: 'Wrinkle in Time,' },
                            { text: 'Out of Africa,' },
                            { text: 'BECOMING  (Michelle Obama),' },
                            { text: 'Things Fall Apart,' },
                            { text: 'Echo of the the Elephants,' },
                            { text: 'A Day in the Life  of Ivan Desonivich,' },
                            { text: 'To Kill a Mocking Bird,' },
                            { text: 'Maasai and I,' },
                            { text: 'For You Are a Kenyan Child,' },
                            { text: 'The Book of Joy (Desmond Tutu and the Dali Lama) to mention a few.' },
                        ],
                    },
                    {
                        type: 'text',
                        text: 'For this term break, each girl selected a woman’s biography.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/kcse-class-2019_gvbbhc.jpg',
                        alt: 'KCSE-Candidates-2019',
                        description: 'KCSE Candidates. Class of 2019.',
                    },
                    {
                        type: 'text',
                        text: 'Our teachers have all been trained in student centered, interactive,  and  interdisciplinary  teaching methodology.  We have a major focus on teaching critical thinking, analysis and interpretation. Book clubs are used extensively in this program. Government schools still rely on rote memorization and parroting back the exact answer which undermines critical thinking.',
                    },
                    {
                        type: 'text',
                        text: 'Environmentally, we aim to teach the best practices for the girls to emulate and share with their families and communities.  Tembea Academy is totally solar powered.  We have eliminated all plastic bags and bottles.  We practice reduce, reuse but there is no recycling available.',
                    },
                    {
                        type: 'text',
                        text: 'We have an extensive tree planting program, as each girl brings a tree to school – especially the traditional medicinal plants. The girls interview their elders about the uses for the plants -and the girls have written a pamphlet about our medicinal garden. Our garden of medicinal plants is the only one we know of in Kenya. ',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904878/Beads/news/florence-ekuri_sgwafw.jpg',
                        alt: 'Florence-Ekuri',
                        description: 'Florence Ekuri is in college training to be a tour guide with Kenya Wildlife Service.',
                    },

                    {
                        type: 'text',
                        text: 'Florence Ekuri is in college training to be a tour guide with Kenya Wildlife Service. She has completed her first year and was honored by Najib Balala, the Cabinet Minister of Kenyan Tourism, as the top student in her class.  She just completed 4 months volunteering with WWF studying rhinos.  She also volunteers at Tembea  teaching  about Kenyan wildlife.  Wildlife is minimally addressed in the Kenyan curriculum.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904880/Beads/news/shcool-project_ulyrwd.jpg',
                        alt: 'cabbage-growing-project',
                        description: 'Some of the 11th grade candidates in their cabbage growing project.',
                    },
                    {
                        type: 'text',
                        text: 'Kenya has faced many droughts and famines and food security is critical.  We use our greenhouses and each girl has a farm plot to produce food for the school. We hope to train a generation that would hopefully mitigate against this sad scenario of food insecurity.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904884/Beads/news/shcool-project2_nklwlr.jpg',
                        alt: 'school-project',
                        description: 'Some of the students in their school agricultural project.',
                    },
                    {
                        type: 'text',
                        text: ' As firm believers in diversification in learning, we continue to expose our girls to as many fields of talent as possible including sports, music, debate, computers and volunteer projects. Many of the girls wrote about their volunteer projects working in hospitals, orphanages, teaching elders and other students reading and writing etc.',
                    },
                    {
                        type: 'text',
                        text: 'Soon, I will be sending a request for school fees for the 2020 school year.  School fee donations are due in September. I leave for Kenya September 3rd  and will reside at the school most of the year.  The best way to contact me is via email.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities. We hope you will join us in January for the 4th graduating class of Tembea Academy.',
            },
        ],
        date: '01-08-2019',
        author: 'Auditor',
    },
];

export const successStoriesData = [
    {
        id: '100',
        category: 'Success Stories',
        title: 'Our first Doctor! Thank you to the generous donors who matched to $50,000!',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707912321/Beads/news/DrMsoka_f7o8qs.jpg',
            alt: 'RachaelMsoka',
            description: 'Rachael Msoka',
        },
        content: [
            {
                type: 'text',
                text: 'Happy Holidays Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'I am so happy to tell you that one of our sponsored girls, Rachael Msoka,  has just graduated from medical school and will intern in OBGYN - this will help so many women in Kenya. We are thrilled to also have a Physician`s Assistant, several nurses and look forward to more sponsored girls entering the medical profession with your amazing continued support. Thank you for your great support making so many girls dreams become a reality.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707912321/Beads/news/DrMsoka_f7o8qs.jpg',
                        alt: 'RachaelMsoka',
                        description: 'Dr Rachael Msoka at her work place.',
                    },
                    {
                        type: 'text',
                        text: 'I am Rachael E. Msoka, and have just graduated with a Bachelor of Medicine from the University of Nairobi. I am from a Tanzanian and have 4 siblings but I am the only one who got a chance to access good education. When my father died on a road accident, I was very young. My mother could not support the whole family and my aunt offered to take me with her to Kenya. One of my sisters ended up marrying at a tender age and our third born later did the same. Ours was a struggle to make ends meet.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707912322/Beads/news/DrMsoka2_nwzi9j.jpg',
                        alt: 'RachaelMsoka',
                        description: 'Rachael`s Graduation Ceremony',
                    },
                    {
                        type: 'text',
                        text: 'Although I was too old, about 12 years, I entered primary school. This was my only chance to learn English, the language used in all Kenyan schools,  since I only spoke my mother tongue. I knew the fees, personal effects  stationary was a challenge for my aunt, but she found a way.',
                    },
                    {
                        type: 'text',
                        text: 'To everyone`s surprise, including mine, I did very well in primary school and was admitted to Moi Girls` Secondary School in Kajiado.',
                    },
                    {
                        type: 'text',
                        text: 'She is married, selected her own husband and has one adorable little girl.  Diana says, “I come from a humble background with many siblings. If it were not for Beads, I would have been married off at a tender age, live in the village forever and never achieve my dreams to be a person of substance for my community. I am eternally grateful to Beads for Education."',
                    },
                    {
                        type: 'text',
                        text: 'It was only with the good fortune of a BEADS sponsorship that I was able to enroll and finish high school and continue to medical school. ',
                    },
                    {
                        type: 'text',
                        text: 'I am honored and humbled by the efforts of BEADS for Education and my sponsors and will always do my best to use my skills wisely and help as many people as I can - especially the needy women.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you, and may the Almighty continue to bless you more.',
            },
            {
                type: 'text',
                text: 'Rachael',
            },
        ],
        date: '01-12-2016',
        author: 'Auditor',
    },
    {
        id: '101',
        category: 'Success Stories',
        title: 'Winter 2019',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907268/Beads/news/1_rtdldf.jpg',
            alt: 'Beads',
            description: 'Winter 2019',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'Hope that this New Year is wonderful for you, your family and friends. We have just celebrated our third graduating class from Tembea Academy. Twenty seven girls graduated and many sponsors joined us for the celebration. Sponsors usually spend several days after graduation volunteering. Everyone can help from reading to our nursery students to teaching internet skills. Sponsors often continue with a safari. We hope that you will join us next January for this once in a lifetime experience. ',
                    },
                    {
                        type: 'text',
                        text: 'All our high school graduates spend one year giving back to their communities. They work as teachers in our primary school before they are eligible to attend college with your very generous sponsorship.  Our girls are studying teaching, geology, project management, internet technology, and nursing to name a few majors.  Our goal is to prepare our girls to be successful young women, critical thinkers, with a strong character and commitment to their families, communities and the nation.',
                    },
                    {
                        type: 'text',
                        text: 'Four of our graduates work at our high school as teachers and another one is our accountant.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/Diana-winter_da77cx.jpg',
                        alt: 'Diana',
                        description: 'Diana featured in Kenya’s Daily Nation newspaper, 2006.',
                    },
                    {
                        type: 'text',
                        text: 'Diana #212 began her sponsorship in 2003 in 6th grade. Shortly after she was featured in Kenya’s Daily Nation newspaper raising awareness for girls’ education.  She attained her B.S. in mathematics at Kenyatta University, Nairobi, Kenya.  Now, she teaches math and business at Tembea Academy. She is also our photographer and Director of Communications.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/Diana-family_nk0ki7.jpg',
                        alt: 'Diana-family',
                        description: 'Diana and her daughter Nikky',
                    },
                    {
                        type: 'text',
                        text: 'She is married, selected her own husband and has one adorable little girl.  Diana says, “I come from a humble background with many siblings. If it were not for Beads, I would have been married off at a tender age, live in the village forever and never achieve my dreams to be a person of substance for my community. I am eternally grateful to Beads for Education."',
                    },
                    {
                        type: 'text',
                        text: 'Ann Wambui  #9 proudly stands with her husband and two children. She graduated from college in 2014 with a B.S. in geology.  She worked with a major geotechnical  firm as a lead geologist determining the safety of a building on a plot of land. She just opened her own geotechnical firm. “My mother was the best tea picker in Kenya, but she did not earn enough money to support us. She had to send me to live with a guardian. I graduated top of my class in 8th grade. Everyone was so happy for me BUT I was so sad. I cried many nights because I had no hope of going to high school.  Then a miracle happened.  I received a BEADS sponsorship and I sang with joy. . If it were not for BEADS I would have been married off as young as 13 into a life of poverty”, Ann reminisces.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/Ann-wambui-family_tcaxbq.jpg',
                        alt: 'Ann-Wambui',
                        description: 'Ann Wambui’s family.',
                    },
                    {
                        type: 'text',
                        text: 'Florence Ekuri # 11 pictured in her Kenya Wildlife Service uniform. She is studying to be a field guide and will be one of the few Kenyan women in this field.  Her sponsorship in 9th grade rescued her from the war torn regions of Kenya. She lost her family during this war and arrived on our doorstep with a determination to receive an education.  We are so proud of her and know that she will have a successful  life.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707902956/Beads/news/florence-kws_eskdya.jpg',
                        alt: 'Florence',
                        description: 'Florence in her KWS Uniform.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '01-04-2019',
        author: 'Debby Rooney -BEADS Cofounder',
    },
    {
        id: '102',
        category: 'Success Stories',
        title: '2019 TERM 2 SPONSOR NEWSLETTER',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907272/Beads/news/mentor_ybe64u.jpg',
            alt: 'Beads',
            description: '2019 TERM 2 SPONSOR NEWSLETTER',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'I hope that you are having a great summer.  This was a very successful term for our girls at Tembea Academy.',
                    },
                    {
                        type: 'text',
                        text: 'We strive to provide quality education and teach our girls “to think”. We enrich the Kenyan curriculum and teaching methodology.  One of our key components is an extensive reading and book club program. In the Kenyan curriculum, students read only 2 books in 11th grade and 2 books in 12th grade.',
                    },
                    {
                        type: 'text',
                        text: 'Our girls read about 14 books a year.  Our book club program includes many classics including:',
                    },
                    {
                        type: 'list',
                        items: [
                            { text: 'The Good Earth,' },
                            { text: 'Harry Potter,' },
                            { text: 'Little House on the Prairie,' },
                            { text: 'Charlotte’s Web,' },
                            { text: 'Wrinkle in Time,' },
                            { text: 'Out of Africa,' },
                            { text: 'BECOMING  (Michelle Obama),' },
                            { text: 'Things Fall Apart,' },
                            { text: 'Echo of the the Elephants,' },
                            { text: 'A Day in the Life  of Ivan Desonivich,' },
                            { text: 'To Kill a Mocking Bird,' },
                            { text: 'Maasai and I,' },
                            { text: 'For You Are a Kenyan Child,' },
                            { text: 'The Book of Joy (Desmond Tutu and the Dali Lama) to mention a few.' },
                        ],
                    },
                    {
                        type: 'text',
                        text: 'For this term break, each girl selected a woman’s biography.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/kcse-class-2019_gvbbhc.jpg',
                        alt: 'KCSE-Candidates-2019',
                        description: 'KCSE Candidates. Class of 2019.',
                    },
                    {
                        type: 'text',
                        text: 'Our teachers have all been trained in student centered, interactive,  and  interdisciplinary  teaching methodology.  We have a major focus on teaching critical thinking, analysis and interpretation. Book clubs are used extensively in this program. Government schools still rely on rote memorization and parroting back the exact answer which undermines critical thinking.',
                    },
                    {
                        type: 'text',
                        text: 'Environmentally, we aim to teach the best practices for the girls to emulate and share with their families and communities.  Tembea Academy is totally solar powered.  We have eliminated all plastic bags and bottles.  We practice reduce, reuse but there is no recycling available.',
                    },
                    {
                        type: 'text',
                        text: 'We have an extensive tree planting program, as each girl brings a tree to school – especially the traditional medicinal plants. The girls interview their elders about the uses for the plants -and the girls have written a pamphlet about our medicinal garden. Our garden of medicinal plants is the only one we know of in Kenya. ',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904878/Beads/news/florence-ekuri_sgwafw.jpg',
                        alt: 'Florence-Ekuri',
                        description: 'Florence Ekuri is in college training to be a tour guide with Kenya Wildlife Service.',
                    },

                    {
                        type: 'text',
                        text: 'Florence Ekuri is in college training to be a tour guide with Kenya Wildlife Service. She has completed her first year and was honored by Najib Balala, the Cabinet Minister of Kenyan Tourism, as the top student in her class.  She just completed 4 months volunteering with WWF studying rhinos.  She also volunteers at Tembea  teaching  about Kenyan wildlife.  Wildlife is minimally addressed in the Kenyan curriculum.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904880/Beads/news/shcool-project_ulyrwd.jpg',
                        alt: 'cabbage-growing-project',
                        description: 'Some of the 11th grade candidates in their cabbage growing project.',
                    },
                    {
                        type: 'text',
                        text: 'Kenya has faced many droughts and famines and food security is critical.  We use our greenhouses and each girl has a farm plot to produce food for the school. We hope to train a generation that would hopefully mitigate against this sad scenario of food insecurity.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904884/Beads/news/shcool-project2_nklwlr.jpg',
                        alt: 'school-project',
                        description: 'Some of the students in their school agricultural project.',
                    },
                    {
                        type: 'text',
                        text: ' As firm believers in diversification in learning, we continue to expose our girls to as many fields of talent as possible including sports, music, debate, computers and volunteer projects. Many of the girls wrote about their volunteer projects working in hospitals, orphanages, teaching elders and other students reading and writing etc.',
                    },
                    {
                        type: 'text',
                        text: 'Soon, I will be sending a request for school fees for the 2020 school year.  School fee donations are due in September. I leave for Kenya September 3rd  and will reside at the school most of the year.  The best way to contact me is via email.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities. We hope you will join us in January for the 4th graduating class of Tembea Academy.',
            },
        ],
        date: '01-08-2019',
        author: 'Auditor',
    },
];

export const featuredNewsData = [
    {
        id: '200',
        category: 'Featured News',
        title: 'Featured in HundrED, Segal Family Foundation, Guidestar and Ashoka Changemakers',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907268/Beads/news/banner_gmfyyr.jpg',
            alt: 'Featured',
            description: 'Featured in Other News',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'text',
                text: 'We hope that this email  finds you and your family well during these challenging times.  Please  stay safe. I am still in Kenya and my flight home has been cancelled. I  miss home but am enjoying the beauty of the school and the work we are  accomplishing.',
                style: {},
            },
            {
                type: 'text',
                text: 'I am pleased to tell you  that none of our 21 staff have been furloughed and we continue to pay  their salaries, social security and health insurance.  And, of course,  this enables them to support their families.  They are very grateful.',
                style: {},
            },
            {
                type: 'text',
                text: 'I am pleased to tell you  that none of our 21 staff have been furloughed and we continue to pay  their salaries, social security and health insurance.  And, of course,  this enables them to support their families.  They are very grateful.',
                style: {},
            },
            {
                type: 'text',
                text: 'Our online classes are  working very well. The teachers and students have a normal school time  table for the day from 9 A.M. until 4 P.M. The girls are learning and  submitting their work for marking. We are pleased with our success as  most schools are not. Many of our college students are also doing online  classes. Below see our online learning link of how the program works.',
                style: {},
            },
            {
                type: 'text',
                text: 'Our school curriculum  focuses on creative and critical thinking, leadership training and each  girls commitment to design a project to address problems in her  community.  Rebecca, 11th grade, started a project on environmental  protection. Her Member of Parliament promised to represent her petition  to the national government.  She was honored as an Ashoka Changemaker  and published in several articles.',
                style: {},
            },
            {
                type: 'text',
                text: '540 Sharlyne and 202 Rebecca have been selected for this year"s Yale Young African Scholar conference to be held next month.',
                style: {},
            },
            {
                type: 'text',
                text: 'BEADS has been featured in  various newsletters including African Elephant Research, Ashoka, Segal  Family Foundation and HundrED all with great visibility and the  opportunity to reach more sponsors for our girls.',
                style: {},
            },
            {
                type: 'text',
                text: 'HundRED.org has also published three of our innovations which you can see in these links:',
                style: {},
            },
            {
                type: 'list',
                items: [
                    { text: 'Online learning in remote areas', url: 'https://hundred.org/en/innovations/online-learning-in-remote-areas' },
                    { text: 'Every girl a changemaker', url: 'https://hundred.org/en/innovations/every-girl-a-changemaker' },
                    { text: 'Develop Creative and Critical Thinking', url: 'https://hundred.org/en/innovations/develop-creative-and-critical-thinking' },
                    { text: 'Our teacher Magaga has become the HundrED ambassador for Kenya', url: 'https://hundred.org/en/users/enos-magaga' },
                ],
            },
            {
                type: 'text',
                text: 'Three of our students are also competing for the HundRED youth ambassador, Kenya.',
                style: {},
            },
            {
                type: 'text',
                text: 'We have updated our website, Facebook and Instagram. Join us to get more updates.',
                style: {},
            },
            {
                type: 'text',
                text: 'At school, we are working  on maintenance by painting dormitories, classrooms, library, kitchen and  the dining hall. Hundreds of windows were painstakingly painted.',
                style: {},
            },
            {
                type: 'text',
                text: 'Although the girls are not here, we are taking care of their goats for the agriculture curriculum project. ',
                style: {},
            },
            {
                type: 'text',
                text: 'At school, we are working  on maintenance by painting dormitories, classrooms, library, kitchen and  the dining hall. Hundreds of windows were painstakingly painted.',
                style: {},
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713334/Beads/news/Beads-concern_hb5t1a.jpg',
                alt: 'Painting-classrooms',
                description: 'Painting classrooms.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713334/Beads/news/Beads-concern2_yxqzps.jpg',
                alt: 'Girls inoculate goats',
                description: 'Girls inoculate goats.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713335/Beads/news/Beads-concern3_bwhnoa.jpg',
                alt: 'Sunflowers from our garden',
                description: 'Sunflowers from our garden.',
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707713335/Beads/news/Beads-concern4_idlm7b.jpg',
                alt: 'broccoli-harvest-from-garden',
                description: 'Our gardener Rajab holding broccoli harvest from the garden.',
            },
            {
                type: 'text',
                text: 'Guidestar, the organization that rates non- profits has upgraded our status from bronze star to silver star and now gold star.',
                style: { fontStyle: 'italic' },
            },
            {
                type: 'image',
                src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851710/Beads/news/gold_Star_obbbw3.png',
                alt: 'Guidestar',
                description: 'Beads for Education, Inc. at Gold Level.',
                style: { widht: '20%', height: '10%' },
            },
            {
                type: 'text',
                text: 'Thank you for your continued generous support and helping us to change lives, one girl at a time.  Stay safe! ',
                style: { fontStyle: 'italic' },
            },
        ],
        date: '02-06-2021',
        author: 'Debbie',
    },
    {
        id: '201',
        category: 'Featured News',
        title: 'Kenyan girls from BEADS selected by YALE Young African Scholars',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907530/Beads/news/Yale-Young-African-Scholars2_tzx1i9.png',
            alt: 'YALE',
            description: 'YALE Young African Scholars',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'It is our prayer that you are all doing fine despite what is going  on in the whole world. Please stay safe, take care of yourself and your  loved ones. This too shall pass. Here is a good excerpt from a poem to cheer you up from our form 4 students "Oh! the Places You will Go" by Dr. Seuss.',
                    },
                    {
                        type: 'video',
                        embedUrl: 'https://www.youtube.com/embed/ATFKtEyxpSY',
                        description: 'Tembea Academy 12th Grade Girls Recite',
                    },
                    {
                        type: 'text',
                        text: 'Beads for Education: Oh! the Places You will Go!',
                    },
                    {
                        type: 'text',
                        text: 'To some good news this month: two of our girls Rebecca, 11th grade  and Sharline, 12th grade got admission to the 2020 Yale Young African  Scholars(YYAS). They were chosen to represent Kenya among applicants  from 40 countries in Africa and travel to Ghana, in West Africa, for a  workshop, meet the other like minded youths who wish to make meaningful  impact as young leaders on the continent and share ideas.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851172/Beads/news/Rebbecca-Yale_gekwfx.jpg',
                        alt: 'Rebecca-Naisimoi',
                        description: '#202 Rebecca Naisimoi',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851172/Beads/news/Yale_cmozyv.jpg',
                        alt: 'Rebeca-YYAS',
                        description: 'Rebeca Admision to Yale Young African  Scholars(YYAS)',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851171/Beads/news/Sharline-Yale_joa7zj.jpg',
                        alt: 'Sharline-Wambui',
                        description: 'Sharline Wambui #540',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707851173/Beads/news/Yale2_s4xcgc.jpg',
                        alt: 'Sharline-Wambui',
                        description: 'Sharline Admision to Yale Young African  Scholars(YYAS)',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you for your continued generous support. Stay safe! ',
            },
        ],
        date: '01-04-2020',
        author: 'Debbie',
    },
];

export const tembeaGraduationData = [
    {
        id: '300',
        category: 'Beads Graduation',
        title: 'Tembea High School Graduation',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/Graduation_mxmbmk.jpg',
            alt: 'Graduation',
            description: 'Tembea High School Graduation.',
        },
        content: [
            {
                type: 'text',
                text: 'This also marks the 10th Anniversary for Beads Tembea Academy, a school established by BEADS for Education in the year 2013 to provide quality education and critical thinking skills.',
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/Graduation_mxmbmk.jpg',
                        alt: 'Graduation',
                        description: 'Tembea High School Graduation.',
                    },
                    {
                        type: 'text',
                        text: 'On January 2017, BEADS sponsors traveled to Tembea High School to attend the graduation ceremony of the first class of students to attend Tembea all four years. The sponsors were greeted with welcoming songs and got to meet the girls`families. Some sponsors traveled to visit the girls` families in their homes. It was a joyful occasion and everyone is very proud of the Tembea graduates. ',
                    },
                    {
                        type: 'text',
                        text: 'Here`s the attached video clip of the event;',
                    },
                    {
                        type: 'video',
                        embedUrl: 'https://www.youtube.com/embed/2LI7wGr-Tlo',
                        description: 'Tembea Academy 2017 Graduation',
                    },
                    {
                        type: 'text',
                        text: 'The graduates are now interning as teachers at our primary school before they are eligible to enter college.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904881/Beads/news/Graduation3_svj7hr.jpg',
                        alt: 'Graduation',
                        description: '2017 TEMBEA ACADEMY GRADUATES.',
                    },
                    {
                        type: 'text',
                        text: ' Fifty of our sponsored graduates are now attending colleges studying to be nurses, accountants, teachers, and a chemical engineer among other majors. ',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707906708/Beads/news/grad-interns_dlelvu.jpg',
                        alt: 'Graduation',
                        description: '2017 TEMBEA ACADEMY GRADUATES.',
                    },
                    {
                        type: 'text',
                        text: 'ALL of these girls need sponsors to continue their education and I hope you will share this with your friends. Together we ARE changing girls’ lives – one girl at a time.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707904882/Beads/news/Graduation2_esnsqh.jpg',
                        alt: 'Graduation',
                        description: '2017 TEMBEA ACADEMY GRADUATES.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '20-12-2023',
        author: 'Auditor',
    },
];

export const communityDevelopmentData = [
    {
        id: '400',
        category: 'Community Development',
        title: 'Maasai girls’ sponsorship Update Term 1 2020',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907698/Beads/news/masai-sponsorship_n7bxrj.jpg',
            alt: 'Maasai-girls',
            description: 'Maasai girls’ sponsorship',
        },
        content: [
            {
                type: 'text',
                text: 'Supporting women education in Kenya, Africa. ',
            },
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'I have been working at our high school in Kenya since September and enjoying every day teaching. We have 100 girls in classes 9 through 12. Another 15 girls were rescued from the Masai Mara from forced early marriage and circumcision by bringing them to our high school.  This brings our total of rescued girls in the past three years to 45.  Ten girls are working at our nursery school as teachers during their gap year and before they enroll in college.  Thirty five young women are attending college through your generous support. ',
                    },
                    {
                        type: 'text',
                        text: 'If you have friends that would like to sponsor a girl, please let me know as we need many more sponsors.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707901409/Beads/news/maasai-girls_wpthkr.jpg',
                        alt: 'Maasai-girls',
                        description: 'Maasai girls joinign Tembea High School',
                    },
                    {
                        type: 'text',
                        text: 'The Mara parents are very poor and the girls arrive at school with nothing.  Above the girls receive their boarding supplies and uniforms from our generous sponsors.',
                    },
                    {
                        type: 'text',
                        text: 'Grace has just graduated from our BEADS High School and is now interning as a teacher at our nursery school.  After successfully completing her internship, she will enroll in the university to study agronomy.  She wants to help the poor grow their own food so that no child will go to bed hungry as she did so many times.  Grace was born in the Kibera slums – the largest slum in Africa. “My mother struggled and fought to feed and educate me and my 3 sisters and 2 brothers.  I never thought I would be able to attend high school due to school fees.  I expected to be married off to a much older man who I had never met or to become a housemaid in a rich man’s house.  In 8th grade, I almost lost all hope. I thought it was a miracle when I was sponsored to join the BEADS High School. I knew my life would change completely.  The stars never shone like this before. Education is the key the key to success,” Grace wrote in her journal.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707901398/Beads/news/Grace_sqhbh3.jpg',
                        alt: 'Grace',
                        description: 'Grace is studying agronomy.',
                    },
                    {
                        type: 'text',
                        text: 'Every year we celebrate all the tribes that attend our school.  This year we have 6 tribes of the 42 in Kenya -   Maasai, Kamba, Luo, Kisii, Digo and Kikuyu. Each tribe builds their traditional hut and greets the other tribes with a welcoming song, an explanation of their hut, how their people live and earn money, a traditional song and closing with their prayer. We do this to counter tribalism which has been rampant in Kenya in many of the past elections.  We continue with a class unit which focuses on genocide in other countries e.g. Rwanda, Kenya, and Germany. This year the unit culminated with a guest speaker who escaped the Hutu and Tutsi genocide in Rwanda.',
                    },
                    {
                        type: 'text',
                        text: 'In academics we continue to improve our scores on the national tests.  Speaking only English at school and having bookclubs weekly are the greatest influence for our academic performance.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707901397/Beads/news/Debby-and-girls_h981ro.jpg',
                        alt: 'Debbie-and-girls',
                        description: '(from left) Elizabeth, Debby, Crystal and Grace.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '01-04-2020',
        author: 'Auditor',
    },
];

export const beadsAlumniData = [
    // 500
];

export const otherNewsData = [
    {
        id: '600',
        category: 'Other News',
        title: '2019 HAPPY HOLIDAYS',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707907698/Beads/news/masai-sponsorship_n7bxrj.jpg',
            alt: 'Maasai-girls',
            description: 'Maasai girls’ sponsorship',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'The year has been great at Tembea Academy. The girls are breaking for a long holiday. They will spend most of their time doing volunteer work in their communities.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707911917/Beads/news/holidays_kuuyzl.jpg',
                        alt: 'Happy-Holidays',
                        description: 'Happy Holidays and a Bountiful New Year 2020!',
                    },
                    {
                        type: 'text',
                        text: 'Our college students continue to enjoy their various majors and the challenges that come with it. There are currently 53 students. This year 16 new students were admitted into college majoring in health education, statistics, food production, tour operations, beauty and accounting. It is through your support that every year we continue to inspire a group of young women to be influential in their communities by attaining college education.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707912003/Beads/news/holidays3_rmiaug.jpg',
                        alt: 'Happy-Holidays',
                        description: 'Some of our 53 girls in college. From Left to Right: Miriam, Florence, Juliet, Jesca, Rose A, Rose N, Lillian, Lonte, Mercy, Annelly, Felister, Sheila, Banice, Mary, Simaloi, Naliaka M, Narasha, Siato, Charity and Faith.',
                    },

                    {
                        type: 'text',
                        text: 'Form Four Class at BEADS Tembea High School will be sitting for their end of course exam which is KCSE (Kenya Certificate of Secondary Education) which is like our SAT’s. It is a month- long session of testing. This will be graded nationally and the results released just before Christmas. It is this exam result that puts the student into the different colleges and majors they will eventually pursue. As such, it is a key determiner of their career paths and an important milestone in their lives.',
                    },
                    {
                        type: 'text',
                        text: 'In the last two years, we have rescued more than 40 girls from forced early marriage – with your help.  We would like to rescue more girls this year.  If you know anyone who would like to sponsor, please let us know.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
        ],
        date: '30-12-2019',
        author: 'Auditor',
    },
    {
        id: '601',
        category: 'Other News',
        title: 'TERMS NEWSLETTER',
        cover: {
            type: 'image',
            src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707913276/Beads/news/terms_am6vlu.jpg',
            alt: 'terms-newsltter',
            description: '2017 TEMBEA ACADEMY GRADUATES',
        },
        content: [
            {
                type: 'text',
                text: 'Dear Sponsors and Friends,',
                style: { fontWeight: 'bold' },
            },
            {
                type: 'paragraph',
                parts: [
                    {
                        type: 'text',
                        text: 'We are pleased to introduce you to our second graduating class from Tembea Academy, the BEADS High School.  The graduates are now interning as teachers at our primary school before they are eligible to enter college.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707913276/Beads/news/terms_am6vlu.jpg',
                        alt: 'terms-newsltter',
                        description: '2017 TEMBEA ACADEMY GRADUATES',
                    },
                    {
                        type: 'text',
                        text: 'Fifty of our sponsored girls are now attending colleges studying to be nurses, accountants, teachers, and a chemical engineer among other majors.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707913277/Beads/news/terms2_hrs63p.jpg',
                        alt: 'terms-newsltter',
                        description: 'Graduate Cynthia teaching at our primary school',
                    },
                    {
                        type: 'text',
                        text: 'My great niece Sophia, Sister Sue and me on safari. On this trip we also interviewed and accepted 20 girls from the remote Masai Mara region. These girls are from traditional Maasai families and many of their fathers have more than 4 wives and 30 or more children. They have just started 9th grade at our high school and are smart, hard-working and a joy to teach.',
                        style: { marginTop: '1rem' }
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707913277/Beads/news/terms3_hglygl.jpg',
                        alt: 'terms-newsltter',
                        description: 'Debbie with Sister Sue, and niece Sophia on safari trip.',
                    },
                    {
                        type: 'image',
                        src: 'https://res.cloudinary.com/self-hosted/image/upload/v1707913278/Beads/news/terms4_fg2v1v.jpg',
                        alt: 'terms-newsltter',
                        description: 'A leap of leopards at the Maasai Mara park.',
                    },
                    {
                        type: 'text',
                        text: 'Many sponsors joined us for the graduation celebrations and continued on for safari.',
                    },
                    {
                        type: 'text',
                        text: 'I hope you will join us in other coming sponsors trips and continue supporting the girls.',
                    },
                ],
            },
            {
                type: 'text',
                text: 'ALL of these girls need sponsors to continue their education and I hope you will share this with your friends.',
            },
            {
                type: 'text',
                text: 'Together we ARE changing girls’ lives – one girl at a time.',
            },
            {
                type: 'text',
                text: 'Thank you from all the sponsored girls, their families and communities.',
            },
            {
                type: 'text',
                text: 'rooneydeb@aol.com  || 609-823-7701',
            },
        ],
        date: '30-03-2018',
        author: 'Debby Rooney -BEADS Cofounder',
    },
];

// Define a variable for the common image for the newsletter
const commonNewsletterImage = 'https://res.cloudinary.com/self-hosted/image/upload/v1707935092/Beads/news/Logo2_xyyuth.jpg';

// Allow serving newsletter PDFs from a CDN (e.g., Cloudinary/R2/S3) for faster downloads.
// Set REACT_APP_NEWSLETTER_CDN_BASE to the CDN folder URL (without the trailing slash).
const newsletterCdnBase = (process.env.REACT_APP_NEWSLETTER_CDN_BASE || '').replace(/\/$/, '');

// Per-file CDN overrides (use when filenames differ from original). Keys are the original
// filenames already referenced below; values are the full CDN URLs for the specific file.
const newsletterCdnOverrides = {
    // 700: How It All Began.
    'How+It+All+Began.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936797/Beads/news/Archives/How_It_All_Began_tcfgaq.pdf',
    // 701: Issue 1
    'BEADS+Newsletter+Issue+1.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936794/Beads/news/Archives/BEADS_Newsletter_Issue_1_tprvrg.pdf',
    // 702: Issue 2
    'BEADS+Newsletter+Issue+2.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936796/Beads/news/Archives/BEADS_Newsletter_Issue_2_xlalnw.pdf',
    // 703: How I Met Joy
    'How+I+Met+Joy.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936799/Beads/news/Archives/How_I_Met_Joy_i0toca.pdf',
    // 704: Issue 3
    'BEADS+Newsletter+Issue+3.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936803/Beads/news/Archives/BEADS_Newsletter_Issue_3_ajtphb.pdf',
    // 705: Issue 4
    'BEADS+Newsletter+Issue+4.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936794/Beads/news/Archives/BEADS_Newsletter_Issue_4_t51ab0.pdf',
    // 706: Issue 5
    'BEADS+Newsletter+Issue+5.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936794/Beads/news/Archives/BEADS_Newsletter_Issue_5_kr4ggt.pdf',
    // 707: Issue 6
    'BEADS+Newsletter+Issue+6.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936795/Beads/news/Archives/BEADS_Newsletter_Issue_6_cpe9ls.pdf',
    // 708: Issue 7
    'BEADS+Newsletter+Issue+7.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936797/Beads/news/Archives/BEADS_Newsletter_Issue_7_xs2hh5.pdf',
    // 709: Issue 8
    'BEADS+Newsletter+Issue+8.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936795/Beads/news/Archives/BEADS_Newsletter_Issue_8_nxbcdh.pdf',
    // 710: Issue 9
    'BEADS+Newsletter+Issue+9.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936795/Beads/news/Archives/BEADS_Newsletter_Issue_9_b50ncr.pdf',
    // 711: Issue 10
    'BEADS+Newsletter+Issue+10.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936807/Beads/news/Archives/BEADS_Newsletter_Issue_10_yejmwl.pdf',
    // 712: Issue 11
    'BEADS+Newsletter+Issue+11.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936796/Beads/news/Archives/BEADS_Newsletter_Issue_11_xp7izc.pdf',
    // 713: Tembea Girls High School
    'Tembea+Girls+High+School.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936800/Beads/news/Archives/Tembea_Girls_High_School_qj714p.pdf',
    // 714: Newsletter 2014
    'Newsletter+2014.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936798/Beads/news/Archives/Newsletter_2014_cizx8y.pdf',
    // 715: Newsletter 2015
    'Newsletter+2015.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936799/Beads/news/Archives/Newsletter_2015_dfkbnt.pdf',
    // 716: Newletter Oct 2015_2
    'Newletter+Oct+2015_2.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936798/Beads/news/Archives/Newletter_Oct_2015_2_b2rngz.pdf',
    // 717: Tembea High School Graduation 2018_2
    'TembeaHighSchoolGraduation2018_2.pdf': 'https://res.cloudinary.com/self-hosted/image/upload/v1707936800/Beads/news/Archives/TembeaHighSchoolGraduation2018_2_zcrgmy.pdf',
};

const buildNewsletterPdfUrl = (fileName) => {
    if (!fileName) return '';
    // If a full URL was provided, use it directly.
    if (/^https?:\/\//i.test(fileName)) {
        return fileName;
    }
    // If we have an override for this filename, use it.
    if (newsletterCdnOverrides[fileName]) {
        return newsletterCdnOverrides[fileName];
    }
    if (newsletterCdnBase) {
        return `${newsletterCdnBase}/${fileName}`;
    }
    // If no CDN base is configured, return empty string to avoid referencing removed local assets.
    return '';
};

export const newsletterArchivesData = [
    {
        id: '700',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'How It All Began.',
        date: 'November 2000',
        pdf: buildNewsletterPdfUrl('How+It+All+Began.pdf'),
    },
    {
        id: '701',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 1: Debby Visits the Sponsored Girls (22 girls)',
        date: 'January 2001',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+1.pdf'),
    },
    {
        id: '702',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 2: 56 Sponsored girls/Sponsor visits.',
        date: 'February 2003',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+2.pdf'),
    },
    {
        id: '703',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'BEADS Co-founder Lisa Stevens tells how she met her sponsored girl.',
        date: 'February 2003',
        pdf: buildNewsletterPdfUrl('How+I+Met+Joy.pdf'),
    },
    {
        id: '704',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 3: 91 Sponsored girls/A visit to Amboseli.',
        date: 'December 2003',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+3.pdf'),
    },
    {
        id: '705',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 4: 132 Sponsored girls/HIV/Aids Training/Interning begins.',
        date: 'September 2004',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+4.pdf'),
    },
    {
        id: '706',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 5: 200Sponsored girls/Women`s Beading Project/HIV/AIDS Training and more.',
        date: 'May 2005',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+5.pdf'),
    },
    {
        id: '707',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 6: 250 Sponsored girls (7 in college)/Walkathon -- Maasai warriors support girls` education.',
        date: 'July 2006',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+6.pdf'),
    },
    {
        id: '708',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 7: Famine Relief (by BEADS volunteer Joyce Tannian).',
        date: 'September 2006',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+7.pdf'),
    },
    {
        id: '709',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 8: 300 Sponsored girls/Read what they are doing now.',
        date: 'April 2008',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+8.pdf'),
    },
    {
        id: '710',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 9: Overview of Sponsorship Program/Quotes from Sponsored Girls.',
        date: 'September 2008',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+9.pdf'),
    },
    {
        id: '711',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 10: Top Ride News.',
        date: 'October 2009',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+10.pdf'),
    },
    {
        id: '712',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Issue 11: HIgh school Graduates/School Improvements/Famine Relief.',
        date: 'May 2010',
        pdf: buildNewsletterPdfUrl('BEADS+Newsletter+Issue+11.pdf'),
    },
    {
        id: '713',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'BEADS Project: Tembea Girls High School.',
        date: 'January 2011',
        pdf: buildNewsletterPdfUrl('Tembea+Girls+High+School.pdf'),
    },
    {
        id: '714',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Education day at Tembea High School.',
        date: 'April 2014',
        pdf: buildNewsletterPdfUrl('Newsletter+2014.pdf'),
    },
    {
        id: '715',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Matching Grant and our Nursery School.',
        date: 'July 2015',
        pdf: buildNewsletterPdfUrl('Newsletter+2015.pdf'),
    },
    {
        id: '716',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: '12th Grade Added in January/Famine Preparation at Tembea.',
        date: 'October 2015',
        pdf: buildNewsletterPdfUrl('Newletter+Oct+2015_2.pdf'),
    },
    {
        id: '717',
        src: commonNewsletterImage,
        alt: 'BEADS Newsletter Archive',
        description: 'Second Tembea High School graduation.',
        date: 'March 2018',
        pdf: buildNewsletterPdfUrl('TembeaHighSchoolGraduation2018_2.pdf'),
    },
];

